import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { saveAs } from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as Highcharts from 'highcharts';
import { MarketCorrectionEmployeePopupComponent } from 'src/app/shared/popups/market-correction-employee-popup/market-correction-employee-popup.component';
import { EmployeeGivenPromotionPopupComponent } from 'src/app/shared/popups/employee-given-promotion-popup/employee-given-promotion-popup.component';
import { EligibleEmployeesPopupComponent } from 'src/app/shared/popups/eligible-employees-popup/eligible-employees-popup.component';
import * as echarts from 'echarts';
import * as XLSX from 'xlsx';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-increment',
  templateUrl: './increment.component.html',
  styleUrls: ['./increment.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class IncrementComponent implements OnInit {
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard';
  buttonColorName: any;
  subModuleButtonColor: any;
  showSetupPopup: boolean = false;
  showSetupLogs: boolean = false;
  currentDate: any = new Date;
  loggedInCompanyFiscalyear: any;
  loggedInUserName: any
  loggedInUserId: any;
  loggedInUserCompanyID: any;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInUserRoleIsEmployee: boolean = false;
  loggedInCompanyReviewCycle: any = null;
  errorMsgForRating: boolean = false;
  approvalByHodDate: any;
  ratingArrayForSetup: any = [];
  addedratingArray: any = [];
  activeIncrementInputTab: boolean = true;
  totalPagesOfIncremnt: any = 0;
  totalIncremnt: any = 0;
  currentPageNumberOfIncremnt: any = 1;
  page: any = 0;
  showingCount: any = 0
  showingOfCount: any = 0;
  selectedManagerYear: any;
  selectedEmployeeYear: any;
  companyYears: any = [];
  selectedYear: any;
  selectedIncrementInputYear: any;
  fromYear: any;
  toYear: any;
  formIncrementPeriodArray: any = [];
  toIncrementPeriodArray: any = [];
  fromIncremnetPeriod: any = null;
  toIncremnetPeriod: any = null;
  cutOffDateForIncrementEligibility: any = null;
  onSelectIncrementTotalCTC: any
  getIndividualBandList: any = [];
  ScoreToFinalScoreConverterPlusCompanyScore: any = [];
  IncrementGridBandList: any = [];
  IndividualKPIPlusCompetencyWt = null;
  DeptKPIScore = null;
  KPIScoreWeightage = null;
  incrementId: any;
  editedIndividualScoreId: number | null = null;
  editedIndividualDeotCompanyScoreId: number | null = null;
  editedBandAndRatingWiseId: number | null = null;
  isFormDisabled: boolean = false;
  onCheckIconView: boolean = true;
  GetOverallIncrementBudgetGridData: any = []
  getDepartmentByYearList: any = [];
  isInValidMaxIndividualKpi = false;
  isInValidMinIndividualKpi = false;
  isInValidMaxIndividualCompetency = false
  isInValidMinIndividualCompetency = false
  IsIndividualTotalWeightage = false
  InvalidIndividualCompetencyMaxTW = false;
  InvalidIndividualCompetencyMinTW = false;
  InvalidDepthKpiMaxScore = false;
  InvalidDepthKpiMinScore = false;
  InvalidcompanyKpiScoreMaxScore = false
  InvalidcompanyKpiScoreMinScore = false;
  InvalidcompanyscoreWT = false;
  IncrementFyYear: any;
  selectFYyear: any;
  disableBtnsOnsendApprovelForMD: any = false;
  isShowOverallBudgetGridBtn: any;
  selectedIncrementInputDept: any;
  selectedIncrementInputBand: any;
  selectedIncrementInputManager: any;
  selectedIncrementInputEmp: any;
  managerId: any;
  employeeId: any;
  getDepartmentsList: any[] = [];
  getBandList: any[] = [];
  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getIncrementInputEligibleTableData: any = []
  getIncrementInputNonEligibleTableData: any = []
  selectedSizeOfIncrementInput: any = 25;
  dropdownSettings: IDropdownSettings = {};
  isAnyColumnInvisible: boolean = false;
  allColumnsInvisible: boolean = false;
  IncrementInputTableHideShowAllData: any[] = [];
  editIndexofRating: any;
  totalIncrementInputEligibleCount: any;
  totalIncrementInputNonEligibleCount: any;
  totalEligibleCount: any;
  totalNonEligibleCount: any;

  totalEligibleTotalFixedCtcPM = 0
  totalEligibleTotalFixedCtcPA = 0;
  totalEligibleEligibleEmp = 0;
  totalEligibleFinalRating = 0;
  totalEligibleIncrementPct = 0;
  totalEligibleDaysServedinIncrementPeriod = 0;
  totalEligibleProratedIncrementPct = 0;
  totalEligibleHODIncrementPct = 0;
  totalEligibleHrAndMdIncrementPct = 0;
  totalEligibleIncrementAmount = 0;
  totalEligibleNoOfPromotionPct = 0;
  totalEligiblePromotionPct = 0;
  totalEligiblePromotionAmount = 0;
  totalEligibleupdatedCtcAfterIAndP = 0;
  totalEligibleMarketBenchMarkCtc = 0;
  totalEligiblemarketCorrectionPct = 0;
  totalEligibleMarketCorrectionAmount = 0;
  totalEligibleFinalIncrementPct = 0;
  totalEligibleFinalIncrementAmount = 0;
  totalEligibleFinalAnnualCtc = 0;
  totalEligibleFinalMonthlyCtc = 0;

  totalNonEligibleTotalFixedCtcPM = 0;
  totalNonEligibleTotalFixedCtcPA = 0;
  totalNonEligibleEligibleEmp = 0;
  totalNonEligibleFinalRating = 0;
  totalNonEligibleIncrementPct = 0;
  totalNonEligibleDaysServedinIncrementPeriod = 0;
  totalNonEligibleProratedIncrementPct = 0;
  totalNonEligibleHODIncrementPct = 0;
  totalNonEligibleHrAndMdIncrementPct = 0;
  totalNonEligibleIncrementAmount = 0;
  totalNonEligiblePromotionPct = 0;
  totalNonEligiblePromotionAmount = 0;
  totalNonEligibleNoOfPromotionPct = 0;
  totalNonEligibleupdatedCtcAfterIAndP = 0;
  totalNonEligibleMarketBenchMarkCtc = 0;
  totalNonEligiblemarketCorrectionPct = 0;
  totalNonEligibleMarketCorrectionAmount = 0;
  totalNonEligibleFinalIncrementPct = 0;
  totalNonEligibleFinalIncrementAmount = 0;
  totalNonEligibleFinalAnnualCtc = 0;
  totalNonEligibleFinalMonthlyCtc = 0;

  IncrementSummaryTableHideShowAllData: any = []
  incrementsummaryCtc: any;
  incrementSummaryFYyear: any;
  incrementSummaryFormYear: any;
  incrementSummaryToYear: any
  getIncrementSummaryTableData: any = []
  selectIncrementReportsYear: any;
  overallIncrementBudgetGridCurrentYear: any
  isEditingRow: number | null = null;
  isFinalIncrementPctFormDisabled: any = true;
  isShowMD: any
  avgPercentageOfMarketCorrection: any
  avgPercentageOfOverallIncrement: any
  avgPercentageOfPromotionIncrement: any
  budgetAmount: any
  budgetPercentage: any
  eligibleEmps: any
  empGivenPromotion: any
  marketCorrectionEmp: any
  noOfEmployees: any

  generWiseBudgetVsActualIcon: any = 'bar';
  GenerWiseBudgetVsActualTable: any = false;
  budgetVsActualIncrementIcon: any = 'bar';
  budgetVsActualIncrementIconTable: any = false;
  ratingWiseIncrementAmountIcon: any = 'bar';
  ratingWiseIncrementAmountTable: any = false;
  bandWiseBudgetVsActualsIcon: any = 'bar';
  bandWiseBudgetVsActualsTable: any = false;
  ratingVsEmpCountIcon: any = 'bar';
  ratingVsEmpCountTable: any = false;
  yearVsBudgetAndActualAmountIcon: any = 'bar';
  yearVsBudgetAndActualAmountTable: any = false;
  deptWiseEligibleAndNonEligibleEmpCountIcon: any = 'bar';
  deptWiseEligibleAndNonEligibleEmpCountTable: any = false;


  //  input select
  selectGenderWiseBudgetVsActualDept: any
  selectedBudgetVsActualIncrementDept: any
  selectRatingWiseIncrementAmount: any
  selectBandWiseBudgetVsActuals: any
  selectratingVsEmpCount: any
  selectYearVsBudgetAndActualAmount: any
  selectDeptWiseEligibleAndNonEligibleEmp: any

  // array
  getGenderWiseBudgetVsActualData: any[] = []
  getBudgetVsActualIncrementData: any[] = [];
  getBudgetVsActualIncrementGraphList: any[] = [];
  ratingWiseIncrementAmountData: any[] = [];
  bandWiseBudgetVsActualsData: any[] = [];
  ratingVsEmpCountData: any[] = [];
  yearVsBudgetAndActualAmountData: any[] = [];
  deptWiseEligibleAndNonEligibleEmpCountData: any[] = [];


  // graph Type
  genderWiseBudgetVsActualDeptGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  BudgetVsActualIncrementGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  ratingWiseIncrementAmountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  bandWiseBudgetVsActualsGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  ratingVsEmpCountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  yearVsBudgetAndActualAmountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  deptWiseEligibleAndNonEligibleEmpCountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  disableIncrementInputFormToHOD: any;
  disableIncrementInputFormToHrAdmin: any;
  disableIncrementSetupAfterMDApproved: any;

  disableIncrementSetupAfterChangeYear: any

  completeStatusErrorMsg: any;

  ShowIncrementInputStatus: any = 'Pending'
  afterMDAndCEOApproval: any;
  approvalStatus: any;
  approvalDateAndTime: any
  afterHODForApprovalDate: any;

  isEditHODApprovedIncrementPct: any;
  isEditHRAdminAndMDCEOApprovedIncrementPct: any;
  loggedInUserIsMD: boolean = false;

  minDate: any;
  maxDate: any;

  incrementCtcPerMonth: any = "";
  incrementCtcPerYear: any = "";
  isShowExcelData: any = false;
  isHideFreezeForTheHodBtn: any = true;
  isApprovedByHr: any;
  ShowApproveForIsPromotedContent: any = true;
  isDisableApproveBtnAfterMDApproved: any = false;
  showIncrementLetterForEmp: any = false;
  getIncrementFyYearList: any[] = [];
  incrementFromYear: any;
  incrementToYear: any;
  isDisabledFinalIncLettersBtn: any = false;
  isInValidMaxOverallBudgetGrid: any
  checkIncrementDepartment: any = true;


  constructor(public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private http: HttpClient,
    private pdfDownload: DownloadAsPdfService) {
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    // if(sessionStorage.getItem('loggedInUserIsMD') == 'true'){
    //   this.loggedInUserIsMD=true;      
    // }else{this.loggedInUserIsMD=false;}    
    if (this.isShowMD || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'HOD') {
      this.loggedInUserIsMD = true;
    } else if (this.loggedInCompanyFiscalyear == 'Manager') {
      this.loggedInUserIsMD = false;
    }
    else {
      this.loggedInUserIsMD = false;
    }

    // if(this.loggedInCompanyFiscalyear === 'Jan_Dec'){
    //   this.minDate = new Date(new Date().getFullYear(), 0, 1);
    //   this.maxDate = new Date(new Date().getFullYear(), 11, 31);
    // }else if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
    //   this.minDate = new Date(new Date().getFullYear() - 1, 0, 1); 
    //   this.maxDate = new Date(new Date().getFullYear(), 2, 31);     
    // }

    const currentYear = new Date().getFullYear();
    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.minDate = new Date(currentYear, 0, 1);
      this.maxDate = new Date(currentYear, 11, 31);
    } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
      this.minDate = new Date(currentYear - 1, 3, 1);
      this.maxDate = new Date(currentYear, 2, 31);
    } else if (this.loggedInCompanyFiscalyear === 'July_Jun') {
      this.minDate = new Date(currentYear - 1, 6, 1);
      this.maxDate = new Date(currentYear, 5, 30);
    } else if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
      this.minDate = new Date(currentYear - 1, 9, 1);
      this.maxDate = new Date(currentYear, 8, 30);
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.getScoreRating();
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin' || this.isShowMD) {
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';
        }
      } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
      }
    })
    this.getpmsyearlist();
    this.getIncrementFyYear();
  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    this.checkStatusForIncrementSetup();
  }


  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/increment', { operation: operation }]);
  }
  onClickBreadcrumPMS() {
    this.router.navigate(['/home/hrportal/increment']);
  }

  onClickUploadfile(uploadfile: any) {
    if (this.afterMDAndCEOApproval != true) {
      this.router.navigate(['/home/hrportal/increment/uploadfile', { uploadfile: uploadfile }]);
    }
  }

  onClickEmailContentBtn(emailContent: any) {
    this.router.navigate(['/home/hrportal/increment/emailContent', { emailContent: emailContent }]);
  }

  onClickIncrementLetterBtn(moduleName: any) {
    this.router.navigate(['/home/hrportal/incrementLetter', { moduleName: moduleName }]);
  }

  onClickLogs(moduleName: any) {
    // this.router.navigate(['/home/hrportal/auidtlogs', { moduleName: moduleName}]);
    this.router.navigate(['/home/hrportal/incrementLogs', { operation: moduleName }]);

  }

  onMenuClose() {
    // Optional: Handle any cleanup when the menu is closed
  }

  previousPageIncrement() {
    if (this.currentPageNumberOfIncremnt < 2) {
      return;
    } else {
      this.currentPageNumberOfIncremnt--;
      this.page--;
    }
  }

  nextPageIncrement() {
    if (this.currentPageNumberOfIncremnt >= this.totalPagesOfIncremnt) {
      return;
    }
    if (this.currentPageNumberOfIncremnt == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPageNumberOfIncremnt++;
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      // data?.data?.yearRanges?.forEach((ele: any) => {
      //   var test = ele.split('_');
      //   let obj = {
      //     year: test[0] + '-' + test[1]
      //   };
      //   this.companyYears.push(obj);
      // });
      const currentYear = new Date().getFullYear();
      data?.data?.yearRanges?.forEach((ele: any) => {
        const [startYear, endYear] = ele.split('_').map(Number);
        if (startYear <= currentYear) {
          this.companyYears.push({ year: `${startYear}-${endYear}` });
        }
      });

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }

      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }

      this.selectedYear = this.companyYears[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
      } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
        this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
      }
      this.getIncrementSetupByYear();
      this.activatedroute.params.subscribe((params: any) => {
        if (params?.operation == 'Setup') {
          this.getSetupAfterMDApproved();
          this.getBandDataFunction();
        }
      })
      this.showCurrentYear();
    });
  }

  // increment Setup
  onYearChange(event: any) {
    var selectedyear = event.value?.split('-');
    this.fromYear = selectedyear[0];
    this.toYear = selectedyear[1];
    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
    } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
      this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
    }
    const currentYear: number = new Date().getFullYear();
    if (parseInt(this.fromYear) !== currentYear) {
      this.disableIncrementSetupAfterChangeYear = true
    } else {
      this.disableIncrementSetupAfterChangeYear = false
    }

    this.getBandDataFunction();
    this.getIncrementSetupByYear();
  }

  getFormMonthsArray(fiscalYear: string, selectedYear: string): string[] {
    const monthYearArray = [];
    const [startYear, endYear] = selectedYear.split('-').map((y) => parseInt(y));

    if (fiscalYear === 'Jan_Dec') {
      for (let month = 0; month < 12; month++) {
        monthYearArray.push(`${this.getMonthName(month)} ${(startYear + 1) % 100}`);
      }
    } else if (fiscalYear === 'Apr_Mar') {
      for (let month = 3; month < 15; month++) {
        const year = month < 12 ? endYear : endYear + 1;
        monthYearArray.push(`${this.getMonthName(month % 12)} ${year % 100}`);
      }
    }

    return monthYearArray;
  }

  private getMonthName(monthIndex: number): string {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNames[monthIndex];
  }

  getIncrementSetupByYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      this.fromIncremnetPeriod = result.data.fromMonth;
      this.toIncremnetPeriod = result.data.toMonth;
      this.cutOffDateForIncrementEligibility = result.data.cutOffDateForIncrement
      this.onSelectIncrementTotalCTC = result.data.incrementOn;
      if (result) {
        this.getOverallIncrementBudgetGrid()
      }
      if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
        this.IncrementBudgetGridCTC = " Fixed CTC of Eligible Employees"

      } else {
        this.IncrementBudgetGridCTC = "Total CTC of Eligible Employees"
      }

    })
  }

  isInvalidFromIncrementPeriod: any;
  isInvalidToIncrementPeriod: any;
  isINvalidCutOffDateForIncrementEligibility: any
  isInvalidIncrementTotalCTC: any
  IncrementBudgetGridCTC: any

  selectIncrementEligibility(data: any) {
    if (data == null) {
      this.isINvalidCutOffDateForIncrementEligibility = true
    } else { this.isINvalidCutOffDateForIncrementEligibility = false }
    if (this.fromIncremnetPeriod == null) {
      this.isInvalidFromIncrementPeriod = true;
    } else { this.isInvalidFromIncrementPeriod = false };
    if (this.toIncremnetPeriod == null) {
      this.isInvalidToIncrementPeriod = true;
    } else { this.isInvalidToIncrementPeriod = false }
  }

  selectFromIncrementPeriood(data: any) {
    if (data == null) {
      this.isInvalidFromIncrementPeriod = true;
    } else { this.isInvalidFromIncrementPeriod = false }
  }

  selectToIncrementPeriood(data: any) {
    if (data == null) {
      this.isInvalidToIncrementPeriod = true;
    } else { this.isInvalidToIncrementPeriod = false }
  }

  selectIncrementToBeGivenOn(data: any) {
    if (data.value == null) {
      this.isInvalidIncrementTotalCTC = true;
    } else { this.isInvalidIncrementTotalCTC = false }
  }

  setUpIncrementCutOff() {
    if (this.fromIncremnetPeriod == null || this.toIncremnetPeriod == null || this.cutOffDateForIncrementEligibility == null
      || this.onSelectIncrementTotalCTC == null) {
      if (this.fromIncremnetPeriod == null) {
        this.isInvalidFromIncrementPeriod = true;
      } else { this.isInvalidFromIncrementPeriod = false; }
      if (this.toIncremnetPeriod == null) {
        this.isInvalidToIncrementPeriod = true;
      } else { this.isInvalidToIncrementPeriod = false; }
      if (this.cutOffDateForIncrementEligibility == null) {
        this.isINvalidCutOffDateForIncrementEligibility = true;
      } else { this.isINvalidCutOffDateForIncrementEligibility = false; }
      if (this.onSelectIncrementTotalCTC == null) {
        this.isInvalidIncrementTotalCTC = true;
      } else { this.isInvalidIncrementTotalCTC = false; }
    } else {
      if (this.disableIncrementSetupAfterMDApproved == true) {
        window.alert("Increment Setup Already Approved by MD/CEO")
      } else {
        this.isInvalidFromIncrementPeriod = false;
        this.isInvalidToIncrementPeriod = false;
        this.isINvalidCutOffDateForIncrementEligibility = false;
        this.isInvalidIncrementTotalCTC = false;
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Save increment setup',
            btn1: 'Cancel',
            btn2: 'Yes',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          const request = {
            "companyId": this.loggedInUserCompanyID,
            "cutOffDate": this.datePipe.transform(this.cutOffDateForIncrementEligibility, "yyyy-MM-dd"),
            "finalIncrementPercentage": null,
            "fromMonth": this.fromIncremnetPeriod,
            "id": null,
            "incrementOn": this.onSelectIncrementTotalCTC,
            "toMonth": this.toIncremnetPeriod,
            "year": this.selectedYear
          }
          this.httpService.callPostService(this.config.incrementCutOffSetup, request).subscribe((result: any) => {
            if (result) {
              this.getIncrementSetupByYear()
            }
          })
        })
      }
    }
  }

  getSetupAfterMDApproved() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      this.approvalStatus = result.data?.mdReviewStatus;
      this.approvalDateAndTime = result.data?.approvalByHrDate;
      const formattedDate = this.datePipe.transform(this.approvalDateAndTime, 'dd-MM-yyyy');
      this.isApprovedByHr = result.data?.isApprovedByHr
      if (result.data?.mdReviewStatus == "Approved") {
        this.disableIncrementSetupAfterMDApproved = true;
      }
      else if (result.data?.mdReviewStatus == "Rejected") {
        this.disableIncrementSetupAfterMDApproved = false;
      }
      else {
        this.disableIncrementSetupAfterMDApproved = false;
      }
    })
  }

  getBandDataFunction() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
    }
    this.httpService.callPostService(this.config.getBandListForIncrement, request).subscribe((result: any) => {
      this.getIndividualBandList = result.data.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        deptKpiScore: null,
        id: null,
        individualCompetencyWeightage: null,
        individualKpiScoreWeightage: null,
        totalWeightage: null
      }));

      this.ScoreToFinalScoreConverterPlusCompanyScore = result.data.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        deptKpiScore: null,
        id: null,
        individualCompetencyWeightage: null,
        individualKpiScoreWeightage: null,
        totalWeightage: null
      }));
      this.IncrementGridBandList = result.data.map((data: any) => ({
        band: data,
        id: [],
        incrementPercentage: [],
      }));
      this.getScoreToFinalConverterIndividual();
      this.getScoreToFinalConverterCompany()
      this.getScoreRating();
      this.getOverallIncrementBudgetGrid();
      this.GetIncrementGrid();
    });
  }

  // Score to final score converter (Individual Score + Individual competency)

  onClickIndividualScoreEdit(itemId: number): void {
    if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
      window.alert("error")
      return;
    } else {
      if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
        this.editedIndividualScoreId = null;
        this.onCheckIconView = true;
        this.isFormDisabled = false
      } else {
        this.editedIndividualScoreId = itemId;
        this.onCheckIconView = true;
        this.isFormDisabled = false
      }

    }

  }

  onSaveIndividualScoreToFinalScoreConverter() {
    if (this.editedIndividualScoreId === null) return
    const editRow = this.getIndividualBandList[this.editedIndividualScoreId];

    const filteredScores = [{
      "band": editRow.band ?? null,
      "id": editRow.id ?? null,
      "individualCompetencyWeightage": editRow.individualCompetencyWeightage ?? null,
      "individualKpiScoreWeightage": editRow.individualKpiScoreWeightage ?? null,
      "totalWeightage": editRow.totalWeightage ?? null
    }].filter((item: any) =>
      item.individualKpiScoreWeightage !== null &&
      item.individualCompetencyWeightage !== null &&
      item.totalWeightage !== null
    );
    if (filteredScores.length === 0) return;
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementSetupId": null,
      "scores": filteredScores,
      "toYear": this.toYear
    };
    if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
      window.alert("error")
      return;
    } else {
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.incrementScoreToFinalScoreConverter, request)
        .subscribe((result: any) => {
          this.getScoreToFinalConverterIndividual();
        });
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false
    }
  }

  getScoreToFinalConverterIndividual() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementId": null,
      "toYear": this.toYear
    }
    if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
      window.alert("error")
      return;
    } else {
      this.httpService.callPostService(this.config.getScoreToFinalConverterIndividual, request)
        .subscribe((result: any) => {
          const apiData = result.data;
          this.getIndividualBandList = this.getIndividualBandList.map((item: any) => {
            const matchingBandData = apiData.find((apiItem: any) => apiItem.band === item.band);
            if (matchingBandData) {
              item.individualKpiScoreWeightage = matchingBandData.individualKpiScoreWeightage;
              item.id = matchingBandData.id
              item.individualCompetencyWeightage = matchingBandData.individualCompetencyWeightage;
              item.totalWeightage = matchingBandData.totalWeightage;
            }
            return item;
          });
          this.editedIndividualScoreId = null;
          this.onCheckIconView = false;
          this.isFormDisabled = false;
          this.loader.dismissLoader();
        });
    }
  }

  IndividualTotalWeightage(item: any) {
    const scoreWeightage: number = Number(item.individualKpiScoreWeightage || 0);
    const competencyWeightage: number = Number(item.individualCompetencyWeightage || 0);
    let totalWeightage = scoreWeightage + competencyWeightage;
    if (totalWeightage > 100 || totalWeightage < 100) {
      this.IsIndividualTotalWeightage = true;
    } else {
      this.IsIndividualTotalWeightage = false;
    }
    if (scoreWeightage < 0) {
      item.individualKpiScoreWeightage = 0
    }
    if (competencyWeightage < 0) {
      item.individualCompetencyWeightage = 0
    }
    item.totalWeightage = totalWeightage;
    this.isInValidMaxIndividualKpi = item.individualKpiScoreWeightage >= 101;
    this.isInValidMinIndividualKpi = item.individualKpiScoreWeightage < 0;
    this.isInValidMaxIndividualCompetency = item.individualCompetencyWeightage >= 101;
    this.isInValidMinIndividualCompetency = item.individualCompetencyWeightage < 0;
  }

  // Score to final score converter (Individual Score + Dept Score + Company Score)

  onClickIndividualDeptcompetencyScoreEdit(itemId: number): void {
    if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
      || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
      this.InvalidcompanyKpiScoreMinScore) {
      window.alert("error")
    } else {
      if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
        this.editedIndividualDeotCompanyScoreId = null;
        this.onCheckIconView = true;
        this.isFormDisabled = false
      } else {
        this.editedIndividualDeotCompanyScoreId = itemId;
        this.onCheckIconView = true;
        this.isFormDisabled = false
      }

    }
  }

  // onSaveincrementScoreToFinalScoreCompanyConverter() {
  //   const filteredScores = this.ScoreToFinalScoreConverterPlusCompanyScore.filter((item: any) =>
  //     item.individualCompetencyWeightage !== null &&
  //     item.deptKpiScore !== null &&
  //     item.companyKpiScore !== null &&
  //     item.totalWeightage !== null
  //   );
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "incrementSetupId": null,
  //     "scores": filteredScores,
  //     "toYear": this.toYear
  //   }

  //   if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
  //     || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
  //     this.InvalidcompanyKpiScoreMinScore) {
  //     window.alert("error")
  //   } else {
  //     this.loader.simpleLoader();
  //     this.httpService.callPostService(this.config.incrementScoreToFinalScoreCompanyConverter, request)
  //       .subscribe((result: any) => {
  //         this.getScoreToFinalConverterCompany();
  //       })
  //     this.editedIndividualDeotCompanyScoreId = null;
  //     this.onCheckIconView = false;
  //     this.isFormDisabled = false;
  //   }
  // }

  onSaveincrementScoreToFinalScoreCompanyConverter() {
    if (this.editedIndividualDeotCompanyScoreId === null) return;
    const editedRow = this.ScoreToFinalScoreConverterPlusCompanyScore[this.editedIndividualDeotCompanyScoreId];
    const filteredScores = [{
      "band": editedRow.band ?? null,
      "id": editedRow.id ?? null,
      "individualCompetencyWeightage": editedRow.individualCompetencyWeightage ?? null,
      "deptKpiScore": editedRow.deptKpiScore ?? null,
      "companyKpiScore": editedRow.companyKpiScore ?? null,
      "totalWeightage": editedRow.totalWeightage ?? null
    }].filter(item =>
      item.individualCompetencyWeightage !== null &&
      item.deptKpiScore !== null &&
      item.companyKpiScore !== null &&
      item.totalWeightage !== null
    );
    if (filteredScores.length === 0) return;
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementSetupId": null,
      "scores": filteredScores,
      "toYear": this.toYear
    };
    if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
      || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
      this.InvalidcompanyKpiScoreMinScore) {
      window.alert("Error");
    } else {
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.incrementScoreToFinalScoreCompanyConverter, request)
        .subscribe((result: any) => {
          this.getScoreToFinalConverterCompany();
        });
      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
    }
  }


  getScoreToFinalConverterCompany() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementId": null,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getScoreToFinalConverterCompany, request)
      .subscribe((result: any) => {
        if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
          || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
          this.InvalidcompanyKpiScoreMinScore) {
          window.alert("error")
        } else {
          const apiData = result.data;
          this.ScoreToFinalScoreConverterPlusCompanyScore = this.ScoreToFinalScoreConverterPlusCompanyScore.map((item: any) => {
            const matchingBandData = apiData.find((apiItem: any) => apiItem.band === item.band);
            if (matchingBandData) {
              item.individualCompetencyWeightage = matchingBandData.individualCompetencyWeightage;
              item.id = matchingBandData.id
              item.deptKpiScore = matchingBandData.deptKpiScore;
              item.companyKpiScore = matchingBandData.companyKpiScore;
              item.totalWeightage = matchingBandData.totalWeightage;
            }
            return item;
          });
          this.editedIndividualDeotCompanyScoreId = null;
          this.onCheckIconView = false;
          this.isFormDisabled = false;
        }
        this.loader.dismissLoader();
      });
  }

  GetScoreToFinalConverterTotalWeightage(item: any) {
    const individualCompetencyWeightage: number = Number(item.individualCompetencyWeightage || 0);
    const deptKpiScore: number = Number(item.deptKpiScore || 0);
    const companyKpiScore: number = Number(item.companyKpiScore || 0);
    let totalWeightage = individualCompetencyWeightage + deptKpiScore + companyKpiScore;
    if (totalWeightage > 100 || totalWeightage < 100) {
      this.InvalidcompanyscoreWT = true;
    } else {
      this.InvalidcompanyscoreWT = false;
    }
    if (individualCompetencyWeightage < 0) {
      item.individualCompetencyWeightage = 0
    }
    if (deptKpiScore < 0) {
      item.deptKpiScore = 0
    }
    if (companyKpiScore < 0) {
      item.companyKpiScore = 0
    }
    item.totalWeightage = totalWeightage;
    this.InvalidIndividualCompetencyMaxTW = item.individualCompetencyWeightage >= 101;
    this.InvalidIndividualCompetencyMinTW = item.individualCompetencyWeightage < 0;
    this.InvalidDepthKpiMaxScore = item.deptKpiScore >= 101;
    this.InvalidDepthKpiMinScore = item.deptKpiScore < 0;
    this.InvalidcompanyKpiScoreMaxScore = item.companyKpiScore >= 101;
    this.InvalidcompanyKpiScoreMinScore = item.companyKpiScore < 0;
  }

  // Score to Rating Converter

  editRating(index: any) {
    this.editIndexofRating = index
  }

  addMoreScoreRating() {
    var maxRange = 0;
    if (this.addedratingArray?.length == 0) {
      maxRange = 0;
    } else {
      for (let i = 0; i < this.addedratingArray?.length; i++) {
        maxRange = this.addedratingArray[i].maxRange;
      }
    }
    this.ratingArrayForSetup.push({
      maxRange: null,
      rating: null,
      minRange: maxRange,
    })
  }
  errorMsgForRange: boolean = false;

  saveAddedScoreRating() {
    this.loader.simpleLoader();
    if (this.ratingArrayForSetup[0].maxRange != null && this.ratingArrayForSetup[0].rating != null) {
      if (!this.isInValidMaxRange && !this.isInValidRating) {
        this.errorMsgForRange = false;
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "fromYear": this.fromYear,
          "incrementSetupId": null,
          "ratings": [
            {
              "id": null,
              "maxScoreRange": this.ratingArrayForSetup[0].maxRange,
              "minScoreRange": this.ratingArrayForSetup[0].minRange,
              "rating": this.ratingArrayForSetup[0].rating
            }
          ],
          "toYear": this.toYear
        }
        this.httpService.callPostService(this.config.incrementScoreToRatingConverter, request).subscribe((result: any) => {
          if (result) {
            this.getScoreRating();
          }
        })
        this.ratingArrayForSetup = []
      } else {
        this.errorMsgForRange = true;
      }
    }
  }

  getScoreRating() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementId": null,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getScoreToRatingConverter, request).subscribe((result: any) => {
      this.addedratingArray = [];
      this.addedratingArray = result.data.map((ele: any) => ({
        maxRange: ele.maxScoreRange,
        minRange: ele.minScoreRange,
        rating: ele.rating,
        id: ele.id,
      }));
      this.loader.dismissLoader();
    })
  }

  isInValidMaxRange = false;
  isInValidRating = false;

  onMaxRangeChange(data: any) {
    if (data.maxRange > data.minRange || isNaN(data.maxRange)) {
      this.isInValidMaxRange = false;
    } else {
      this.isInValidMaxRange = true;
    }
  }

  onRatingEmpty(data: any) {
    if (isNaN(data.rating)) {
      this.isInValidRating = false;
    } else {
      this.isInValidRating = true;
    }
  }

  removecreatedScoresRating() {
    this.errorMsgForRange = false;
    this.isInValidMaxRange = false;
    this.isInValidRating = false;
    this.ratingArrayForSetup = [];
  }

  deleteScoreRating() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete all ratings?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "fromYear": this.fromYear,
          "incrementId": null,
          "toYear": this.toYear
        }
        this.httpService.callPostService(this.config.deleteRatings, request).subscribe((result: any) => {
          this.getScoreRating();
          this.IncrementGridBandList.flatMap((band: any) =>
            this.addedratingArray.map((rating: any, colId: any) => {
              band.incrementPercentage[colId] = "";
            })
          );
        })
      }
    });

  }

  // Overall Increment Budget Grid 
  showCurrentYear() {
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear}`;
    } else {
      this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
      if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
        if (currentMonth < 3) {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear - 1}-${currentYear}`;
        } else {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
        }
      }
      if (this.loggedInCompanyFiscalyear === 'July_Jun') {
        if (currentMonth < 6) {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear - 1}-${currentYear}`;
        } else {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
        }
      }
      if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
        if (currentMonth < 9) {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear - 1}-${currentYear}`;
        } else {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
        }
      }
    }


    // if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
    //   this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear}`;
    // } else {
    //   this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
    // }
  }

  getOverallIncrementBudgetGrid() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.GetOverallIncrementBudgetGridData = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
        id: ele.id,
        noOfEligibleEmployees: ele.noOfEligibleEmployees,
        totalCtcOfEmployees: ele.totalCtcOfEmployees,
        finalIncrementPercentage: ele.finalIncrementPercentage,
        finalIncrementAmount: ele.finalIncrementAmount
      }));
      this.loader.dismissLoader();
    })
  }

  editRow(index: number) {
    // if (this.isInValidMaxOverallBudgetGrid) {
    //   return;
    // }else{
    //   this.isInValidMaxOverallBudgetGrid = false;
    if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.isEditingRow = null;
      this.isShowOverallBudgetGridBtn = true
    } else {
      this.isEditingRow = index;
      this.isShowOverallBudgetGridBtn = true
    }
    // }

  }

  OnSaveFinalIncrementPercentage(data: any) {
    if (!this.isInValidMaxOverallBudgetGrid) {
      const request = {
        companyId: this.loggedInUserCompanyID,
        cutOffDate: null,
        finalIncrementPercentage: data.finalIncrementPercentage,
        fromMonth: null,
        id: data.id || null,
        incrementOn: null,
        toMonth: null,
        year: data.year
      };
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.addFinalIncrementPercentage, request).subscribe((result: any) => {
        this.isEditingRow = null;
        this.isFinalIncrementPctFormDisabled = true;
        if (result) {
          this.getOverallIncrementBudgetGrid()
        }
      });
    }
  }

  cancelEdit(index: number) {
    this.isEditingRow = null;
    this.getOverallIncrementBudgetGrid();
    this.isFinalIncrementPctFormDisabled = true;
  }

  GetOverallIncrementBudgetGridIncrementPct(item: any) {
    const IncrementPercentage: number = Number(item.finalIncrementPercentage || 0);
    if (IncrementPercentage < 0) {
      item.finalIncrementPercentage = 0;
    }

    if (item.finalIncrementPercentage == null || item.finalIncrementPercentage == 0) {
      this.isInValidMaxOverallBudgetGrid = true
    } else {
      this.isInValidMaxOverallBudgetGrid = false
    }
  }

  // Increment Grid - Band & Rating Wise 

  onClickBandAndRatingWiseEdit(rowId: any) {
    if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.editedBandAndRatingWiseId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    } else {
      this.editedBandAndRatingWiseId = rowId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }

  }

  // onSaveIncrementGrid() {
  //   this.editedBandAndRatingWiseId = null;
  //   this.onCheckIconView = false;
  //   this.isFormDisabled = false;
  //   const getResult = this.IncrementGridBandList.flatMap((band: any) =>
  //     this.addedratingArray.map((rating: any, colId: any) => ({
  //       "band": band.band,
  //       "id": band.id[colId],
  //       "incrementPercentage": band.incrementPercentage[colId] || null,
  //       "ratingId": rating.id
  //     }))
  //   );
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "incrementSetupId": null,
  //     "list": getResult,
  //     "toYear": this.toYear
  //   };
  //   this.loader.simpleLoader();
  //   this.httpService.callPostService(this.config.incrementGrid, request).subscribe((result: any) => {
  //     if (result) {
  //       this.GetIncrementGrid();
  //     }
  //   });
  // }

  onSaveIncrementGrid() {
    if (this.editedBandAndRatingWiseId === null) return;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    const editedBand = this.IncrementGridBandList[this.editedBandAndRatingWiseId];
    const getResult = this.addedratingArray
      .map((rating: any, colId: any) => ({
        "band": editedBand.band,
        "id": editedBand.id[colId],
        "incrementPercentage": editedBand.incrementPercentage[colId] || null,
        "ratingId": rating.id
      }))
      .filter((item: any) => item.incrementPercentage !== null && item.incrementPercentage !== undefined);
    if (getResult.length === 0) return;
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementSetupId": null,
      "list": getResult,
      "toYear": this.toYear
    };

    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.incrementGrid, request).subscribe((result: any) => {
      if (result) {
        this.GetIncrementGrid();
      }
    });
  }



  GetIncrementGrid() {
    this.editedBandAndRatingWiseId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementId": null,
      "toYear": this.toYear
    };
    this.httpService.callPostService(this.config.getIncrementGrid, request).subscribe((result: any) => {
      if (result && result.data) {
        const IncrementPercentageData: any = {};
        result.data.forEach((item: any) => {
          if (!IncrementPercentageData[item.band]) {
            IncrementPercentageData[item.band] = {
              band: item.band,
              id: [],
              incrementPercentage: []
            };
          }
          IncrementPercentageData[item.band].incrementPercentage.push(item.incrementPercentage);
          IncrementPercentageData[item.band].id.push(item.id);
        });
        this.IncrementGridBandList.forEach((existingItem: any) => {
          if (IncrementPercentageData[existingItem.band]) {
            existingItem.incrementPercentage = IncrementPercentageData[existingItem.band].incrementPercentage;
            existingItem.id = IncrementPercentageData[existingItem.band].id;
          }
        });
      }
      this.loader.dismissLoader();
    });
  }
  InvalidBandAndRatingWise(item: any, colId: any) {
    let value = Number(item.incrementPercentage[colId]);
    if (value <= 0) {
      item.incrementPercentage[colId] = 0;
    }
  }

  // Increment FY Year
  getIncrementFyYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
      }));

      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.IncrementFyYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
      var test: any = this.IncrementFyYear?.split('-');
      this.incrementFromYear = test[0];
      this.incrementToYear = test[1];
      if (!this.loggedInUserIsMD) {
        this.sendApproveForIsPromoted();
        this.getLetterAfterApprovel()
      } else {

        this.checkStatusForIncrementSetup();
        this.getFreezForTheHODStatus();
        this.getIncrementInputTableHideShowAllData();
        this.getIncrementSummaryTableHideShowAllData();
        this.getIncrementReportsTableHideShowAllData();
      }
    })
  }

  selectedIncrementFYYear(event: any) {
    const demovalue = event.value.toString();
    const selectedYear = demovalue.split('-')
    this.incrementFromYear = selectedYear[0];
    this.incrementToYear = selectedYear[1];

    if (this.IncrementFyYear) {
      this.checkStatusForIncrementSetup();
    }
  }

  checkStatusForIncrementSetup() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.checkSetupForBands, request).subscribe((result: any) => {
      if (result.status === true) {
        if (this.loggedInUserRole == 'Employee') {
          this.sendApproveForIsPromoted()
        } else {
          this.completeStatusErrorMsg = true;
          this.getDepartmentByYear();
          if (this.selectedTypeTabName == 'Dashboard') {
            this.getIncrementCounterList();
            this.BudgetVsActualGraph();
            this.genderWiseBudgetVsActualGraph();
            this.BudgetVsActualIncrementDeptGraph();
            this.RatingWiseIncrementAmountGraph()
            this.bandWiseBudgetVsActualsGraph();
            this.ratingVsEmpCountGraph();
            this.yearVsBudgetAndActualAmountGraph();
            this.deptWiseEligibleAndNonEligibleEmpCountGraph();
          }
          if (this.selectedTypeTabName == 'Increment Input') {
            this.getMDApprovedData();
            this.getIncrementInputisEligibleTableData();
            this.getIncrementInputisNonEligibleTableData();
            this.getApproveByHodData();
          }
          if (this.selectedTypeTabName == 'Increment Summary') {
            this.getIncrementSummaryData();
          }
          if (this.selectedTypeTabName == 'Reports') {
            this.getIncrementReportsEligibleData();
            this.getIncrementReportsNonEligibleData();
          }
        }
      } else {
        this.completeStatusErrorMsg = false;
      }

    })
  }

  getDepartmentByYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "isEligible": this.checkIncrementDepartment
    }
    this.httpService.callPostService(this.config.getDepartmentsByYearRange, request).subscribe((result: any) => {
      this.getDepartmentByYearList = result.data.map((ele: any) => ({
        id: ele,
        name: ele
      }))
    })
  }

  // increment Dashboard

  // Counter
  getIncrementCounterList() {
    let request = {}
    // if(this.loggedInUserRole == 'HOD'){
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": null,
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    // }else{
    //   request = {
    //     "companyId": this.loggedInUserCompanyID,
    //     "depts": null,
    //     "fromYear": this.incrementFromYear,
    //     "isHod": false,
    //     "toYear": this.incrementToYear
    //   }  
    // }
    this.httpService.callPostService(this.config.getCounters, request).subscribe((result: any) => {
      this.avgPercentageOfMarketCorrection = result.data.avgPercentageOfMarketCorrection;
      this.avgPercentageOfOverallIncrement = result.data.avgPercentageOfOverallIncrement;
      this.avgPercentageOfPromotionIncrement = result.data.avgPercentageOfPromotionIncrement;
      this.budgetAmount = result.data.budgetAmount;
      this.budgetPercentage = result.data.budgetPercentage;
      this.eligibleEmps = result.data.eligibleEmps;
      this.empGivenPromotion = result.data.empGivenPromotion;
      this.marketCorrectionEmp = result.data.marketCorrectionEmp;
      this.noOfEmployees = result.data.noOfEmployees;
    })
  }

  onClickMarketCorrectionEmp() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(MarketCorrectionEmployeePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onClickEmpGivenPromotion() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EmployeeGivenPromotionPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onClickEligibleEmployees() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EligibleEmployeesPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // Budget Vs Actua Graph 
  BudgetVsActualGraph() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": null,
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getBudgetvsActual, request).subscribe((result: any) => {
      this.BudgetVsActualBarGraph(result.data);
    });
  };

  BudgetVsActualBarGraph(data: any) {
    const chartDom = document.getElementById('budgetVsActualGraph');
    const myChart = echarts.init(chartDom);

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    const totalActual = parseFloat(data.actualAmount);
    const totalBudget = parseFloat(data.budgetAmount);

    const option = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      yAxis: {
        type: 'category',
        data: [''],
        name: 'Category',
        nameLocation: 'middle',
        nameTextStyle: { fontSize: 14, padding: 20 },
        axisTick: { show: false },
        axisLabel: { show: false }
      },
      xAxis: {
        type: 'value',
        name: '',
        nameLocation: 'middle',
        nameTextStyle: { fontSize: 14, padding: 20 },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        },
        splitLine: { show: false }
      },
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          data: [totalBudget],
          itemStyle: { color: '#393186' },
          label: {
            show: true,
            position: 'right',
            color: '#000',
            fontSize: 12,
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          data: [totalActual],
          itemStyle: { color: '#F3820E' },
          label: {
            show: true,
            position: 'right',
            color: '#000',
            fontSize: 12,
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },

      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '10%',
        bottom: '15%',
        containLabel: true
      }
    };

    myChart.setOption(option);
  }

  OnClickDownloadBudgetvsActualGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'budgetVsActualGraph', // chartId
      '', // tableId
      'Budget vs Actual', // Title
      null, // Department
    );
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "BudgetvsActual",
    //   "reportType": "Bar Graph",
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Gender wise - Budget vs Actual Graph

  selectedGenderWieBudgetVsActualDept() {
    this.genderWiseBudgetVsActualGraph()
    // if(this.selectGenderWiseBudgetVsActualDept.length > 0){
    //   this.genderWiseBudgetVsActualGraph()
    // }
  }

  genderWiseBudgetVsActualGraph() {
    let request = {};
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectGenderWiseBudgetVsActualDept ? [this.selectGenderWiseBudgetVsActualDept] : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getBudgetvsActualForGenderOfDepts, request).subscribe((result: any) => {
      this.getGenderWiseBudgetVsActualData = result.data
      this.genderWiseBudgetVsActualDeptGraphType.bar = this.genderWiseBudgetVsActualBarGraph(this.getGenderWiseBudgetVsActualData);
      this.genderWiseBudgetVsActualDeptGraphType.pie = this.genderWiseBudgetVsActualPieGraph(this.getGenderWiseBudgetVsActualData);
      this.genderWiseBudgetVsActualDeptGraphType.line = this.genderWiseBudgetVsActualLineGraph(this.getGenderWiseBudgetVsActualData);
      this.switchGenderWiseBudgetVsActualGraphType('bar');
    });
  }

  switchGenderWiseBudgetVsActualGraphType(graphType: any) {
    this.generWiseBudgetVsActualIcon = graphType;
    this.GenerWiseBudgetVsActualTable = false;

    const dom = document.getElementById("GenderWiseBudgetVsActualGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.genderWiseBudgetVsActualBarGraph(this.getGenderWiseBudgetVsActualData)
      }
      if (graphType == 'pie') {
        this.genderWiseBudgetVsActualPieGraph(this.getGenderWiseBudgetVsActualData)
      }
      if (graphType == 'line') {
        this.genderWiseBudgetVsActualLineGraph(this.getGenderWiseBudgetVsActualData)
      }
      if (this.genderWiseBudgetVsActualDeptGraphType[graphType] && typeof this.genderWiseBudgetVsActualDeptGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.genderWiseBudgetVsActualDeptGraphType[graphType], true);
      }
    }
  }

  genderWiseBudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.gender),
          name: 'Gender',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Increment',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
      ]
    };
  }


  genderWiseBudgetVsActualPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };
    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  genderWiseBudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format((num / 1e7)) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format((num / 1e5)) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format((num / 1e3)) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.gender),
          name: 'Gender',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
        }
      ]
    };
  }


  GenderWiseBudgetVsActualTableData() {
    this.generWiseBudgetVsActualIcon = '';
    this.GenerWiseBudgetVsActualTable = true;
  }

  downloadGenderWiseBudgetVsActualGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'GenderWiseBudgetVsActualGraph', // chartId
      'genderWiseBudgetVsActualTable', // tableId
      'Gender wise - Budget vs Actual', // Title
      this.selectGenderWiseBudgetVsActualDept ? this.selectGenderWiseBudgetVsActualDept : 'All', // Department
    );
    // var reportType: any;
    // if (this.GenerWiseBudgetVsActualTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.generWiseBudgetVsActualIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.generWiseBudgetVsActualIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectGenderWiseBudgetVsActualDept ? [this.selectGenderWiseBudgetVsActualDept] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "GenderwiseBudgetvsActual",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Budget vs actual Increment Graph 

  onSelectBudgetVsActualIncrementDept() {
    if (this.selectedBudgetVsActualIncrementDept.length > 0) {
      this.BudgetVsActualIncrementDeptGraph();
    }
  };

  onDeSelectBudgetVsActualIncrementDept() {
    this.BudgetVsActualIncrementDeptGraph();
  };

  selectAllBudgetVsActualIncrementDept(data: any) {
    this.selectedBudgetVsActualIncrementDept = data;
    this.onSelectBudgetVsActualIncrementDept();
  };

  onDeSelectAllBudgetVsActualIncrementDept() {
    this.selectedBudgetVsActualIncrementDept = [];
    this.BudgetVsActualIncrementDeptGraph();
  };

  BudgetVsActualIncrementDeptGraph() {
    let request = {}
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectedBudgetVsActualIncrementDept ? this.selectedBudgetVsActualIncrementDept.map((ele: any) => ele.name) : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }

    this.httpService.callPostService(this.config.getBudgetvsActualForDepts, request).subscribe((result: any) => {
      this.getBudgetVsActualIncrementData = result.data;

      this.BudgetVsActualIncrementGraphType.bar = this.BudgetVsActualIncrementDeptBarGraph(this.getBudgetVsActualIncrementData);
      this.BudgetVsActualIncrementGraphType.pie = this.BudgetVsActualIncrementDeptPieGraph(this.getBudgetVsActualIncrementData);
      this.BudgetVsActualIncrementGraphType.line = this.BudgetVsActualIncrementDeptLineGraph(this.getBudgetVsActualIncrementData);
      this.switchBudgetVsActualIncrementGraphType('bar');
    });
  }

  switchBudgetVsActualIncrementGraphType(graphType: any) {
    this.budgetVsActualIncrementIcon = graphType;
    this.budgetVsActualIncrementIconTable = false;

    const dom = document.getElementById("BudgetvsActualIncrementStatusGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.BudgetVsActualIncrementDeptBarGraph(this.getBudgetVsActualIncrementData)
      }
      if (graphType == 'pie') {
        this.BudgetVsActualIncrementDeptPieGraph(this.getBudgetVsActualIncrementData)
      }
      if (graphType == 'line') {
        this.BudgetVsActualIncrementDeptLineGraph(this.getBudgetVsActualIncrementData)
      }
      if (this.BudgetVsActualIncrementGraphType[graphType] && typeof this.BudgetVsActualIncrementGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.BudgetVsActualIncrementGraphType[graphType], true);
      }
    }
  }

  BudgetVsActualIncrementDeptBarGraph(data: any): echarts.EChartsOption {

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Budget Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  BudgetVsActualIncrementDeptPieGraph(data: any): echarts.EChartsOption {

    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  BudgetVsActualIncrementDeptLineGraph(data: any): echarts.EChartsOption {

    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
    };
  }


  switchBudgetVsActualIncrementTable() {
    this.budgetVsActualIncrementIcon = '';
    this.budgetVsActualIncrementIconTable = true;
  }

  downloadBudgetVsActualIncrementGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'BudgetvsActualIncrementStatusGraph', // chartId
      'budgetvsActualIncrementStatusTable', // tableId
      'Budget vs actual Increment', // Title
      (this.selectedBudgetVsActualIncrementDept && this.selectedBudgetVsActualIncrementDept.length > 0) ? this.selectedBudgetVsActualIncrementDept.map((ele: any) => ele.name) : 'All',
    );
    // var reportType: any;
    // if (this.budgetVsActualIncrementIconTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.budgetVsActualIncrementIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.budgetVsActualIncrementIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const selectedDepartments = (this.selectedBudgetVsActualIncrementDept && this.selectedBudgetVsActualIncrementDept.length > 0)
    //   ? this.selectedBudgetVsActualIncrementDept.map((ele: any) => ele.name)
    //   : this.getDepartmentByYearList.map((ele: any) => ele.name);
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": selectedDepartments,
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "BudgetvsActualIncrement",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }

    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Rating wise increment amount Graph

  selectedRatingWiseIncrementAmount() {
    this.RatingWiseIncrementAmountGraph()
  }

  RatingWiseIncrementAmountGraph() {
    let request = {};
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectRatingWiseIncrementAmount ? [this.selectRatingWiseIncrementAmount] : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getBudgetvsActualForRatingOfDept, request).subscribe((result: any) => {
      this.ratingWiseIncrementAmountData = result.data

      this.ratingWiseIncrementAmountGraphType.bar = this.ratingWiseIncrementAmountBarGraph(this.ratingWiseIncrementAmountData);
      this.ratingWiseIncrementAmountGraphType.pie = this.ratingWiseIncrementAmountPieGraph(this.ratingWiseIncrementAmountData);
      this.ratingWiseIncrementAmountGraphType.line = this.ratingWiseIncrementAmountLineGraph(this.ratingWiseIncrementAmountData);
      this.switchRatingWiseIncrementAmountGraphType('bar');
    });
  }

  switchRatingWiseIncrementAmountGraphType(graphType: any) {
    this.ratingWiseIncrementAmountIcon = graphType;
    this.ratingWiseIncrementAmountTable = false;

    const dom = document.getElementById("ratingWiseIncrementAmountStatusGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.ratingWiseIncrementAmountBarGraph(this.ratingWiseIncrementAmountData)
      }
      if (graphType == 'pie') {
        this.ratingWiseIncrementAmountPieGraph(this.ratingWiseIncrementAmountData)
      }
      if (graphType == 'line') {
        this.ratingWiseIncrementAmountLineGraph(this.ratingWiseIncrementAmountData)
      }
      if (this.ratingWiseIncrementAmountGraphType[graphType] && typeof this.ratingWiseIncrementAmountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.ratingWiseIncrementAmountGraphType[graphType], true);
      }
    }
  }

  ratingWiseIncrementAmountBarGraph(data: any): echarts.EChartsOption {

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Increment amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '20%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '20%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  ratingWiseIncrementAmountPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  ratingWiseIncrementAmountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
    };
  }

  switchRatingWiseIncrementAmountTableData() {
    this.ratingWiseIncrementAmountIcon = '';
    this.ratingWiseIncrementAmountTable = true;
  }

  downloadRatingWiseIncrementAmountGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'ratingWiseIncrementAmountStatusGraph', // chartId
      'ratingWiseIncrementAmountStatusTable', // tableId
      'Rating wise increment amount (budget vs actual)', // Title
      this.selectRatingWiseIncrementAmount ? this.selectRatingWiseIncrementAmount : 'All', // Department
    );

    // var reportType: any;
    // if (this.ratingWiseIncrementAmountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.ratingWiseIncrementAmountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.ratingWiseIncrementAmountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectRatingWiseIncrementAmount ? [this.selectRatingWiseIncrementAmount] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "RatingwiseIncrementAmount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Band wise budget Vs actuals Graph

  selectedBandWiseBudgetVsActuals() {
    this.bandWiseBudgetVsActualsGraph()
  }

  bandWiseBudgetVsActualsGraph() {
    let request = {};
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectBandWiseBudgetVsActuals ? [this.selectBandWiseBudgetVsActuals] : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getBudgetvsActualForBandsOfDept, request).subscribe((result: any) => {
      this.bandWiseBudgetVsActualsData = result.data
      this.bandWiseBudgetVsActualsGraphType.bar = this.bandWiseBudgetVsActualsBarGraph(this.bandWiseBudgetVsActualsData);
      this.bandWiseBudgetVsActualsGraphType.pie = this.bandWiseBudgetVsActualsPieGraph(this.bandWiseBudgetVsActualsData);
      this.bandWiseBudgetVsActualsGraphType.line = this.bandWiseBudgetVsActualsLineGraph(this.bandWiseBudgetVsActualsData);
      this.switchBandWiseBudgetVsActualsGraphType('bar');
    });
  }

  switchBandWiseBudgetVsActualsGraphType(graphType: any) {
    this.bandWiseBudgetVsActualsIcon = graphType;
    this.bandWiseBudgetVsActualsTable = false;

    const dom = document.getElementById("bandWiseBudgetVsActualsStatusGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.bandWiseBudgetVsActualsBarGraph(this.bandWiseBudgetVsActualsData)
      }
      if (graphType == 'pie') {
        this.bandWiseBudgetVsActualsPieGraph(this.bandWiseBudgetVsActualsData)
      }
      if (graphType == 'line') {
        this.bandWiseBudgetVsActualsLineGraph(this.bandWiseBudgetVsActualsData)
      }
      if (this.bandWiseBudgetVsActualsGraphType[graphType] && typeof this.bandWiseBudgetVsActualsGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.bandWiseBudgetVsActualsGraphType[graphType], true);
      }
    }
  }

  bandWiseBudgetVsActualsBarGraph(data: any): echarts.EChartsOption {

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.band),
          name: 'Band',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Budget Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  bandWiseBudgetVsActualsPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  bandWiseBudgetVsActualsLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.band),
          name: 'Band',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
    };
  }

  switchBandWiseBudgetVsActualsTableData() {
    this.bandWiseBudgetVsActualsIcon = '';
    this.bandWiseBudgetVsActualsTable = true;
  }

  downloadBandWiseBudgetVsActualsGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'bandWiseBudgetVsActualsStatusGraph', // chartId
      'bandWiseBudgetVsActualsStatusTable', // tableId
      'Band wise budget Vs actuals', // Title
      this.selectBandWiseBudgetVsActuals ? this.selectBandWiseBudgetVsActuals : 'All', // Department
    );
    // var reportType: any;
    // if (this.bandWiseBudgetVsActualsTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.bandWiseBudgetVsActualsIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.bandWiseBudgetVsActualsIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectBandWiseBudgetVsActuals ? [this.selectBandWiseBudgetVsActuals] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "BandwiseBudgetVsActuals",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }
  // Rating vs Employee count Graph

  selectedratingVsEmpCount() {
    this.ratingVsEmpCountGraph()
  }

  ratingVsEmpCountGraph() {
    let request = {};
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectratingVsEmpCount ? [this.selectratingVsEmpCount] : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getRatingVsWmployeeCount, request).subscribe((result: any) => {
      this.ratingVsEmpCountData = result.data
      this.ratingVsEmpCountGraphType.bar = this.ratingVsEmpCountBarGraph(this.ratingVsEmpCountData);
      this.ratingVsEmpCountGraphType.pie = this.ratingVsEmpCountPieGraph(this.ratingVsEmpCountData);
      this.ratingVsEmpCountGraphType.line = this.ratingVsEmpCountLineGraph(this.ratingVsEmpCountData);
      this.switchRatingVsEmpCountGraphType('bar');
    });
  }

  switchRatingVsEmpCountGraphType(graphType: any) {
    this.ratingVsEmpCountIcon = graphType;
    this.ratingVsEmpCountTable = false;

    const dom = document.getElementById("ratingvsEmployeeCountStatusGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.ratingVsEmpCountBarGraph(this.ratingVsEmpCountData)
      }
      if (graphType == 'pie') {
        this.ratingVsEmpCountPieGraph(this.ratingVsEmpCountData)
      }
      if (graphType == 'line') {
        this.ratingVsEmpCountLineGraph(this.ratingVsEmpCountData)
      }
      if (this.ratingVsEmpCountGraphType[graphType] && typeof this.ratingVsEmpCountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.ratingVsEmpCountGraphType[graphType], true);
      }
    }
  }

  ratingVsEmpCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 0)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Count',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Count',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.employeeCount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 0),
          },
        },
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  ratingVsEmpCountPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };
    const pieChartData = data.map((ele: any) => ({
      value: ele.employeeCount,
      name: ele.rating
    }));

    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Employee Count by Rating',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: pieChartData
        }
      ]
    };
  }



  ratingVsEmpCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let result = '';
          params.forEach((item: any) => {
            result += `${item.seriesName}: ${formatNumber(item.data)}<br/>`;
          });
          return result;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Count',
          type: 'line',
          data: data.map((ele: any) => ele.employeeCount),
        }
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
    };
  }

  switchRatingVsEmpCountTable() {
    this.ratingVsEmpCountIcon = '';
    this.ratingVsEmpCountTable = true;
  }

  OnClickDownloadRatingVsEmpCountGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'ratingvsEmployeeCountStatusGraph', // chartId
      'ratingvsEmployeeCountStatusTable', // tableId
      'Rating vs Employee count', // Title
      this.selectratingVsEmpCount ? this.selectratingVsEmpCount : 'All', // Department
    );
    // var reportType: any;
    // if (this.ratingVsEmpCountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.ratingVsEmpCountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.ratingVsEmpCountIcon == 'pie') {
    //     reportType = 'Donut Graph'
    //   }
    //   if (this.ratingVsEmpCountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectratingVsEmpCount ? [this.selectratingVsEmpCount] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "RatingvsEmployeecount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Year vs Budget & Actual Amount Graph

  selectedYearVsBudgetAndActualAmount() {
    this.yearVsBudgetAndActualAmountGraph()
  }

  yearVsBudgetAndActualAmountGraph() {
    let request = {};
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectYearVsBudgetAndActualAmount ? [this.selectYearVsBudgetAndActualAmount] : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getBudgetvsActualForThreeYears, request).subscribe((result: any) => {
      this.yearVsBudgetAndActualAmountData = result.data.map((ele: any) => ({
        actualAmount: ele.actualAmount,
        budgetAmount: ele.budgetAmount,
        year: `${ele.fromYear}-${ele.toYear}`
      }))
      this.yearVsBudgetAndActualAmountGraphType.bar = this.yearVsBudgetAndActualAmountBarGraph(this.yearVsBudgetAndActualAmountData);
      this.yearVsBudgetAndActualAmountGraphType.pie = this.yearVsBudgetAndActualAmountPieGraph(this.yearVsBudgetAndActualAmountData);
      this.yearVsBudgetAndActualAmountGraphType.line = this.yearVsBudgetAndActualAmountLineGraph(this.yearVsBudgetAndActualAmountData);
      this.switchYearVsBudgetAndActualAmountGraphType('bar');
    });
  }

  switchYearVsBudgetAndActualAmountGraphType(graphType: any) {
    this.yearVsBudgetAndActualAmountIcon = graphType;
    this.yearVsBudgetAndActualAmountTable = false;

    const dom = document.getElementById("yearVsBudgetandActualAmountStatusGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.yearVsBudgetAndActualAmountBarGraph(this.yearVsBudgetAndActualAmountData)
      }
      if (graphType == 'pie') {
        this.yearVsBudgetAndActualAmountPieGraph(this.yearVsBudgetAndActualAmountData)
      }
      if (graphType == 'line') {
        this.yearVsBudgetAndActualAmountLineGraph(this.yearVsBudgetAndActualAmountData)
      }
      if (this.yearVsBudgetAndActualAmountGraphType[graphType] && typeof this.yearVsBudgetAndActualAmountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.yearVsBudgetAndActualAmountGraphType[graphType], true);
      }
    }
  }

  yearVsBudgetAndActualAmountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    const formatYear = (year: string) => {
      const [startYear, endYear] = year.split('-');
      return endYear && startYear !== endYear ? `${startYear}-${endYear.slice(-2)}` : startYear;
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => formatYear(ele.year)),
          name: 'Year',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Budget & Actual Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }


  yearVsBudgetAndActualAmountPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  yearVsBudgetAndActualAmountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };
    const formatYear = (year: string) => {
      const [startYear, endYear] = year.split('-');
      return endYear && startYear !== endYear ? `${startYear}-${endYear.slice(-2)}` : startYear;
    };
    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => formatYear(ele.year)),
          name: 'Year',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchYearVsBudgetAndActualAmountTable() {
    this.yearVsBudgetAndActualAmountIcon = '';
    this.yearVsBudgetAndActualAmountTable = true;
  }

  downloadYearVsBudgetAndActualAmountGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'yearVsBudgetandActualAmountStatusGraph', // chartId
      'yearVsBudgetandActualAmountStatusTable', // tableId
      'Year vs Budget & Actual Amount', // Title
      this.selectYearVsBudgetAndActualAmount ? this.selectYearVsBudgetAndActualAmount : 'All', // Department
    );
    // var reportType: any;
    // if (this.yearVsBudgetAndActualAmountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.yearVsBudgetAndActualAmountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.yearVsBudgetAndActualAmountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectYearVsBudgetAndActualAmount ? [this.selectYearVsBudgetAndActualAmount] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "YearvsBudgetActualAmount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Dept wise Eligible and not eligible employee count Graph


  onSelectselectedDeptWiseEligibleAndNonEligibleEmpCount() {
    if (this.selectDeptWiseEligibleAndNonEligibleEmp.length > 0) {
      this.deptWiseEligibleAndNonEligibleEmpCountGraph()
    }
  }

  onDeSelectselectedDeptWiseEligibleAndNonEligibleEmpCount() {
    this.deptWiseEligibleAndNonEligibleEmpCountGraph()
  }

  selectAllselectedDeptWiseEligibleAndNonEligibleEmpCount(data: any) {
    this.selectDeptWiseEligibleAndNonEligibleEmp = data;
    this.onSelectselectedDeptWiseEligibleAndNonEligibleEmpCount();
  }
  onDeSelectAllselectedDeptWiseEligibleAndNonEligibleEmpCount() {
    this.selectDeptWiseEligibleAndNonEligibleEmp = [];
    this.deptWiseEligibleAndNonEligibleEmpCountGraph()
  }

  deptWiseEligibleAndNonEligibleEmpCountGraph() {
    let request = {}
    request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectDeptWiseEligibleAndNonEligibleEmp ? this.selectDeptWiseEligibleAndNonEligibleEmp.map((ele: any) => ele.name) : [],
      "fromYear": this.incrementFromYear,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "toYear": this.incrementToYear
    }

    this.httpService.callPostService(this.config.getDeptwiseWligibleVsNonEligibleCount, request).subscribe((result: any) => {
      this.deptWiseEligibleAndNonEligibleEmpCountData = result.data;
      this.deptWiseEligibleAndNonEligibleEmpCountGraphType.bar = this.deptWiseEligibleAndNonEligibleEmpCountBarGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
      this.deptWiseEligibleAndNonEligibleEmpCountGraphType.pie = this.deptWiseEligibleAndNonEligibleEmpCounttPieGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
      this.deptWiseEligibleAndNonEligibleEmpCountGraphType.line = this.deptWiseEligibleAndNonEligibleEmpCountLineGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
      this.switchDeptWiseEligibleAndNonEligibleEmpCountGraphType('bar');
    });
  }

  switchDeptWiseEligibleAndNonEligibleEmpCountGraphType(graphType: any) {
    this.deptWiseEligibleAndNonEligibleEmpCountIcon = graphType;
    this.deptWiseEligibleAndNonEligibleEmpCountTable = false;

    const dom = document.getElementById("deptWiseEligibleAndNonEligibleEmpCountStatusGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.deptWiseEligibleAndNonEligibleEmpCountBarGraph(this.deptWiseEligibleAndNonEligibleEmpCountData)
      }
      if (graphType == 'pie') {
        this.deptWiseEligibleAndNonEligibleEmpCounttPieGraph(this.deptWiseEligibleAndNonEligibleEmpCountData)
      }
      if (graphType == 'line') {
        this.deptWiseEligibleAndNonEligibleEmpCountLineGraph(this.deptWiseEligibleAndNonEligibleEmpCountData)
      }
      if (this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType] && typeof this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType], true);
      }
    }
  }

  deptWiseEligibleAndNonEligibleEmpCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 0)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Department',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Budget Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 24
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Eligible',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.eligibleCount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 0),
          },
        },
        {
          name: 'Non Eligible',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.nonEligibleCount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 0),
          },
        },
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  deptWiseEligibleAndNonEligibleEmpCounttPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    const eligibleCount = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.eligibleCount), 0);
    const nonEligibleCount = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.nonEligibleCount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: eligibleCount, name: 'Eligible' },
            { value: nonEligibleCount, name: 'Non Eligible' }
          ]
        }
      ]
    };
  }

  deptWiseEligibleAndNonEligibleEmpCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };
    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Department',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let result = '';
          params.forEach((item: any) => {
            result += `${item.seriesName}: ${formatNumber(item.data)}<br/>`;
          });
          return result;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0],
        }
      ],
      series: [
        {
          name: 'Eligible',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.eligibleCount || 0))
        },
        {
          name: 'Non Eligible',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.nonEligibleCount || 0))
        }
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
    };
  }

  switchDeptWiseEligibleAndNonEligibleEmpCountTable() {
    this.deptWiseEligibleAndNonEligibleEmpCountIcon = '';
    this.deptWiseEligibleAndNonEligibleEmpCountTable = true;
  }

  downloadDeptWiseEligibleEmpCoungGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'deptWiseEligibleAndNonEligibleEmpCountStatusGraph', // chartId
      'deptWiseEligibleAndNonEligibleEmpCountStatusTable', // tableId
      'Dept wise Eligible and not eligible employee count', // Title
      (this.selectDeptWiseEligibleAndNonEligibleEmp && this.selectDeptWiseEligibleAndNonEligibleEmp.length > 0)
        ? this.selectDeptWiseEligibleAndNonEligibleEmp.map((ele: any) => ele.name) : 'All');
    // var reportType: any;
    // if (this.deptWiseEligibleAndNonEligibleEmpCountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.deptWiseEligibleAndNonEligibleEmpCountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.deptWiseEligibleAndNonEligibleEmpCountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const selectedDepartments = (this.selectDeptWiseEligibleAndNonEligibleEmp && this.selectDeptWiseEligibleAndNonEligibleEmp.length > 0)
    //   ? this.selectDeptWiseEligibleAndNonEligibleEmp.map((ele: any) => ele.name)
    //   : this.getDepartmentByYearList.map((ele: any) => ele.name);
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": selectedDepartments,
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "DeptwiseEligibleAndNotEligibleEmployeeCount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }
  // end

  // Increment Input

  onClickIncrementIntputActiveTab(data: any) {
    this.activeIncrementInputTab = data;
    if (this.activeIncrementInputTab === true) {
      this.checkIncrementDepartment = true;
      this.getDepartmentByYear();
      this.selectedIncrementInputDept = '';
      this.selectedIncrementInputBand = ""
      this.selectedIncrementInputManager = "";
      this.selectedIncrementInputEmp = "";
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
    } else if (this.activeIncrementInputTab === false) {
      this.checkIncrementDepartment = false;
      this.getDepartmentByYear();
      this.selectedIncrementInputDept = '';
      this.selectedIncrementInputBand = ""
      this.selectedIncrementInputManager = "";
      this.selectedIncrementInputEmp = "";
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  // select department

  onSelectIncrementInputDept() {
    if (this.selectedIncrementInputDept.length > 0) {
      this.getBandList = [];
      this.selectedIncrementInputBand = ""
      this.selectedIncrementInputManager = "";
      this.selectedIncrementInputEmp = "";
      this.getBandListByDepartment();
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
    } else {
      this.getBandList = [];
      this.selectedIncrementInputBand = ""
      this.selectedIncrementInputManager = "";
      this.selectedIncrementInputEmp = "";
    }
  }

  onDeSelectIncrementInputDept() {
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getManagerList = [];
    this.selectedIncrementInputBand = ""
    this.selectedIncrementInputManager = "";
    this.selectedIncrementInputEmp = "";
    this.getBandListByDepartment();
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  selectAllIncrementInputDept(items: any): void {
    this.selectedIncrementInputDept = items;
    this.onSelectIncrementInputDept();
    this.selectedIncrementInputBand = ""
    this.selectedIncrementInputManager = "";
    this.selectedIncrementInputEmp = "";
  }

  onDeSelectAllIncrementInputDept() {
    this.selectedIncrementInputDept = [];
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getManagerList = [];
    this.selectedIncrementInputBand = ""
    this.selectedIncrementInputManager = "";
    this.selectedIncrementInputEmp = "";
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  // Select Band

  getBandListByDepartment() {
    const request: any = {
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.map((dept: any) => dept.name),
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getBandListByDepartment, request)
      .subscribe((result: any) => {
        if (result.data) {
          this.getBandList = result.data.map((ele: any) => ({
            id: ele,
            name: ele
          })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
        }
      });
  }

  onSelectdIncrementInputBand() {
    if (this.selectedIncrementInputBand.length > 0) {
      this.getManagerList = [];
      this.selectedIncrementInputManager = "";
      this.selectedIncrementInputEmp = "";
      this.getManagerListByBand();
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
    } else {
      this.getManagerList = [];
      this.selectedIncrementInputManager = "";
      this.selectedIncrementInputEmp = "";
    }
  }

  onDeSelectdIncrementInputBand() {
    this.getManagerList = [];
    this.getEmployeeList = [];
    this.selectedIncrementInputManager = "";
    this.selectedIncrementInputEmp = "";
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  selectAllIncrementInputBand(items: any): void {
    this.selectedIncrementInputBand = items;
    this.selectedIncrementInputManager = "";
    this.selectedIncrementInputEmp = "";
    this.onSelectdIncrementInputBand()
  }

  onDeSelectAllIncrementInputBand() {
    this.selectedIncrementInputBand = [];
    this.getManagerList = [];
    this.selectedIncrementInputManager = "";
    this.selectedIncrementInputEmp = "";
    this.getEmployeeList = [];
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  // select Manager

  getManagerListByBand() {
    const request: any = {
      bands: this.selectedIncrementInputBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getManagerListByBand, request).subscribe((result: any) => {
      if (result.data) {
        this.getManagerList = result.data.map((ele: any) => ({
          name: ele.name,
          id: ele.id,
          managerId: ele.employeeId
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
      }
    });
  }

  onSelectIncrementInputdManager() {
    if (this.selectedIncrementInputManager.length > 0) {
      this.getEmployeeList = [];
      this.selectedIncrementInputEmp = "";
      this.getEmployeeListByManager()
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
    } else {
      this.getEmployeeList = [];
      this.selectedIncrementInputEmp = "";
    }
  }

  onDeSelectdIncrementInputdManager() {
    this.getEmployeeList = [];
    this.selectedIncrementInputEmp = "";
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  selectAllIncrementInputdManager(items: any): void {
    this.selectedIncrementInputManager = items;
    this.selectedIncrementInputEmp = "";
    this.onSelectIncrementInputdManager()

  }

  onDeSelectAllIncrementInputdManager() {
    this.selectedIncrementInputManager = [];
    this.getEmployeeList = [];
    this.selectedIncrementInputEmp = "";
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  // select Employee 

  getEmployeeListByManager() {
    const request = {
      bands: this.selectedIncrementInputBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear,
      userId: this.selectedIncrementInputManager.map((ele: any) => ele.id),
      isEligible: this.checkIncrementDepartment
    }
    this.httpService.callPostService(this.config.getEmployeesListByManager, request).subscribe((result: any) => {
      if (result.data) {
        this.getEmployeeList = result.data.map((ele: any) => ({
          name: ele.name,
          id: ele.id
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectdIncrementInputEmp() {
    if (this.selectedIncrementInputEmp.length > 0) {
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  onDeSelectdIncrementInputEmp() {
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  selectAllIncrementInputEmp(items: any) {
    this.selectedIncrementInputEmp = items;
    this.onSelectdIncrementInputEmp()
  }

  onDeSelectAllIncrementInputEmp() {
    this.selectedIncrementInputEmp = [];
    this.getIncrementInputEligibleTableData = []
    this.getIncrementInputNonEligibleTableData = []
    this.getIncrementInputisEligibleTableData();
    this.getIncrementInputisNonEligibleTableData();
  }

  countEligibleEmployees(departmentList: any[]): number {
    return departmentList.reduce((total, department) => {
      return total + department.bandGrades.reduce((bandTotal: any, bandGrade: any) => {
        return bandTotal + bandGrade.employeeData.filter((employee: any) => employee.isEligible).length;
      }, 0);
    }, 0);
  }

  countNonEligibleEmployees(departmentList: any[]): number {
    return departmentList.reduce((total, department) => {
      return total + department.bandGrades.reduce((bandTotal: any, bandGrade: any) => {
        return bandTotal + bandGrade.employeeData.filter((employee: any) => !employee.isEligible).length;
      }, 0);
    }, 0);
  }

  getIncrementInputTableHideShowAllData() {
    if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
      this.incrementCtcPerMonth = "Fixed CTC p.m."
      this.incrementCtcPerYear = "Fixed CTC p.a."

    } else {
      this.incrementCtcPerMonth = "Total CTC p.m."
      this.incrementCtcPerYear = "Total CTC p.a."
    }

    this.IncrementInputTableHideShowAllData = [
      {
        "fieldId": 1,
        "isVisible": true,
        "fieldName": "Department",
        "position": 1,
        "isEditable": true
      },
      {
        "fieldId": 2,
        "isVisible": true,
        "fieldName": "Band",
        "position": 2,
        "isEditable": true
      },
      {
        "fieldId": 3,
        "isVisible": true,
        "fieldName": "Employee",
        "position": 3,
        "isEditable": true
      },
      {
        "fieldId": 4,
        "isVisible": true,
        "fieldName": "Manager",
        "position": 4,
        "isEditable": true
      },
      {
        "fieldId": 5,
        "isVisible": true,
        "fieldName": "HOD",
        "position": 5,
        "isEditable": true
      },
      {
        "fieldId": 6,
        "isVisible": true,
        "fieldName": "Designation",
        "position": 6,
        "isEditable": true
      },
      {
        "fieldId": 7,
        "isVisible": true,
        "fieldName": "DOJ",
        "position": 7,
        "isEditable": true
      },
      {
        "fieldId": 8,
        "isVisible": true,
        "fieldName": this.incrementCtcPerMonth,
        "position": 8,
        "isEditable": true
      },
      {
        "fieldId": 9,
        "isVisible": true,
        "fieldName": this.incrementCtcPerYear,
        "position": 9,
        "isEditable": true
      },
      {
        "fieldId": 10,
        "isVisible": true,
        "fieldName": "Eligible Emp.",
        "position": 10,
        "isEditable": true
      },
      {
        "fieldId": 11,
        "isVisible": true,
        "fieldName": "Individual KPI + Competency Score",
        "position": 11,
        "isEditable": true
      },
      {
        "fieldId": 12,
        "isVisible": true,
        "fieldName": "Department Score (out of 100)",
        "position": 12,
        "isEditable": true
      },
      {
        "fieldId": 13,
        "isVisible": true,
        "fieldName": "Company Score (out of 100)",
        "position": 13,
        "isEditable": true
      },
      {
        "fieldId": 14,
        "isVisible": true,
        "fieldName": "Final Score",
        "position": 14,
        "isEditable": true
      },
      {
        "fieldId": 15,
        "isVisible": true,
        "fieldName": "Final Rating",
        "position": 15,
        "isEditable": true
      },
      {
        "fieldId": 16,
        "isVisible": true,
        "fieldName": "Increment %",
        "position": 16,
        "isEditable": true
      },
      {
        "fieldId": 17,
        "isVisible": true,
        "fieldName": "Days Served in the Increment Period",
        "position": 17,
        "isEditable": true
      },
      {
        "fieldId": 18,
        "isVisible": true,
        "fieldName": "Prorated Increment %",
        "position": 18,
        "isEditable": true
      },
      {
        "fieldId": 19,
        "isVisible": true,
        "fieldName": "Increment Amount",
        "position": 19,
        "isEditable": true
      },
      {
        "fieldId": 20,
        "isVisible": true,
        "fieldName": "No Promotion Last 3 Year",
        "position": 20,
        "isEditable": true
      },
      {
        "fieldId": 21,
        "isVisible": true,
        "fieldName": "Promotion",
        "position": 21,
        "isEditable": true
      },
      {
        "fieldId": 22,
        "isVisible": true,
        "fieldName": "Promotion %",
        "position": 22,
        "isEditable": true
      },
      {
        "fieldId": 23,
        "isVisible": true,
        "fieldName": "Promotion Amount",
        "position": 23,
        "isEditable": true
      },
      {
        "fieldId": 24,
        "isVisible": true,
        "fieldName": "Updated CTC after Increment & Promotion",
        "position": 24,
        "isEditable": true
      },
      {
        "fieldId": 25,
        "isVisible": true,
        "fieldName": "Market BenchMark CTC",
        "position": 25,
        "isEditable": true
      },
      {
        "fieldId": 26,
        "isVisible": true,
        "fieldName": "Market Correction %",
        "position": 26,
        "isEditable": true
      },
      {
        "fieldId": 27,
        "isVisible": true,
        "fieldName": "Market Correction Amount",
        "position": 27,
        "isEditable": true
      },
      {
        "fieldId": 28,
        "isVisible": true,
        "fieldName": "Final Increment % p.a",
        "position": 28,
        "isEditable": true
      },
      {
        "fieldId": 29,
        "isVisible": true,
        "fieldName": `Increment % in ${(new Date()).getFullYear() - 3}`,
        "position": 29,
        "isEditable": true
      },
      {
        "fieldId": 30,
        "isVisible": true,
        "fieldName": `Increment % in ${(new Date()).getFullYear() - 2}`,
        "position": 30,
        "isEditable": true
      },
      {
        "fieldId": 31,
        "isVisible": true,
        "fieldName": `Increment % in ${(new Date()).getFullYear() - 1}`,
        "position": 31,
        "isEditable": true
      },
      {
        "fieldId": 32,
        "isVisible": true,
        "fieldName": "HOD Approved Increment %",
        "position": 32,
        "isEditable": true
      },
      {
        "fieldId": 33,
        "isVisible": true,
        "fieldName": "HR Admin & MD/CEO Approved Increment %",
        "position": 33,
        "isEditable": true
      },
      {
        "fieldId": 34,
        "isVisible": true,
        "fieldName": "Final Increment Amount",
        "position": 34,
        "isEditable": true
      },
      {
        "fieldId": 35,
        "isVisible": true,
        "fieldName": "Final Annual Revised CTC (post increment)",
        "position": 35,
        "isEditable": true
      },
      {
        "fieldId": 36,
        "isVisible": true,
        "fieldName": "Final Monthly Revised CTC (post increment)",
        "position": 36,
        "isEditable": true
      },
      {
        "fieldId": 37,
        "isVisible": true,
        "fieldName": "Increment Letter Format",
        "position": 37,
        "isEditable": true
      }
    ]
  }

  getIncrementColumnName(yearsAgo: number): string {
    return `Increment % in ${new Date().getFullYear() - yearsAgo}`;
  }

  onSelectIncrementInputHideShowCheckBox() {
    this.isAnyColumnInvisible = this.IncrementInputTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.IncrementInputTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  onClickShowAllHeader() {
    this.IncrementInputTableHideShowAllData?.forEach((ele: any, ind: any) => {
      this.IncrementInputTableHideShowAllData[ind].isVisible = true;
    });
    this.onSelectIncrementInputHideShowCheckBox()
  }

  updateIncrementInputColumnVisibility(data: any, index: any) {
    this.IncrementInputTableHideShowAllData[index].isVisible = false;
    this.onSelectIncrementInputHideShowCheckBox()
  }

  getIncrementInputColumnVisibility(fieldName: string): boolean {
    const column = this.IncrementInputTableHideShowAllData.find(item => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  searchIncrementInputTableData: any = null;

  onIncrementInputSearch(data: any) {
    var search = ''
    this.searchIncrementInputTableData = data;
    if (data == '') {
      this.searchIncrementInputTableData = null;
      this.getIncrementInputisEligibleTableData();
      this.getIncrementInputisNonEligibleTableData();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getIncrementInputisEligibleTableData();
            this.getIncrementInputisNonEligibleTableData();
          },
            500);
        }
      },
        1500);
    }
  }



  getIncrementInputisEligibleTableData() {
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      if (this.selectedIncrementInputEmp) {
        const request = {
          "band": this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
          "employeeId": this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": true,
          "manager": this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          this.totalEligibleCount = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": true,
          "manager": [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          this.totalEligibleCount = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      }
      this.isEditHODApprovedIncrementPct = false;
      this.isEditHRAdminAndMDCEOApprovedIncrementPct = true;
    } else {
      if (this.selectedIncrementInputDept || this.selectedIncrementInputBand || this.selectedIncrementInputEmp || this.selectedIncrementInputManager) {
        const request = {
          "band": this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
          "employeeId": this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": false,
          "manager": this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          this.totalEligibleCount = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": false,
          "manager": [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          this.totalEligibleCount = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      }
      this.isEditHODApprovedIncrementPct = true;
      this.isEditHRAdminAndMDCEOApprovedIncrementPct = false;
    }
  }

  calculateInputEligibleTotals(data: any[]): void {
    this.totalEligibleTotalFixedCtcPM = 0;
    this.totalEligibleTotalFixedCtcPA = 0;
    this.totalEligibleEligibleEmp = 0;
    this.totalEligibleFinalRating = 0;
    this.totalEligibleIncrementPct = 0;
    this.totalEligibleDaysServedinIncrementPeriod = 0;
    this.totalEligibleProratedIncrementPct = 0;
    this.totalEligibleHODIncrementPct = 0;
    this.totalEligibleHrAndMdIncrementPct = 0;
    this.totalEligibleIncrementAmount = 0;
    this.totalEligibleNoOfPromotionPct = 0;
    this.totalEligiblePromotionPct = 0;
    this.totalEligiblePromotionAmount = 0;
    this.totalEligibleupdatedCtcAfterIAndP = 0;
    this.totalEligibleMarketBenchMarkCtc = 0;
    this.totalEligiblemarketCorrectionPct = 0;
    this.totalEligibleMarketCorrectionAmount = 0;
    this.totalEligibleFinalIncrementPct = 0;
    this.totalEligibleFinalIncrementAmount = 0;
    this.totalEligibleFinalAnnualCtc = 0;
    this.totalEligibleFinalMonthlyCtc = 0;

    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          this.totalEligibleTotalFixedCtcPM += parseFloat(employee.monthlyCtc || 0);
          this.totalEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
          this.totalEligibleEligibleEmp += employee.isEligible ? 1 : 0;
          this.totalEligibleFinalRating += parseFloat(employee.finalRating || 0);

          if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
            this.totalEligibleIncrementPct += parseFloat(employee.incrementPercentage);
            totalIncrementPctCount++;
          }

          if (employee.daysServed !== null && employee.daysServed !== undefined) {
            this.totalEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
            totalDaysServedCount++;
          }

          if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
            this.totalEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
            totalProratedIncrementPctCount++;
          }

          if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
            this.totalEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
            totalHODIncrementPctCount++;
          }

          if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
            this.totalEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
            totalHrAndMdIncrementPctCount++;
          }

          if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
            this.totalEligiblePromotionPct += parseFloat(employee.promotionPercentage);
            totalPromotionPctCount++;
          }

          this.totalEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
          this.totalEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
          this.totalEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
          this.totalEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
          this.totalEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

          if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
            this.totalEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
            totalFinalIncrementPctCount++;
          }

          if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
            this.totalEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
            totalMarketCorrectionPctCount++;
          }

          this.totalEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
          this.totalEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
          this.totalEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
          this.totalEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
        });
      });
    });

    if (totalFinalIncrementPctCount > 0) {
      this.totalEligibleFinalIncrementPct = parseFloat((this.totalEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.totalEligiblemarketCorrectionPct = parseFloat((this.totalEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.totalEligiblePromotionPct = parseFloat((this.totalEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.totalEligibleHODIncrementPct = parseFloat((this.totalEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.totalEligibleHrAndMdIncrementPct = parseFloat((this.totalEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.totalEligibleIncrementPct = parseFloat((this.totalEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.totalEligibleDaysServedinIncrementPeriod = parseFloat((this.totalEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }
    if (totalProratedIncrementPctCount > 0) {
      this.totalEligibleProratedIncrementPct = parseFloat((this.totalEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }







  getIncrementInputisNonEligibleTableData() {
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      if (this.selectedIncrementInputEmp) {
        const request = {
          "band": this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
          "employeeId": this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": true,
          "manager": this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputNonEligibleTableData = result.data;
          this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);
          this.totalNonEligibleCount = this.getIncrementInputNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": true,
          "manager": [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputNonEligibleTableData = result.data;
          this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);
          this.totalNonEligibleCount = this.getIncrementInputNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
        this.isEditHODApprovedIncrementPct = false;
        this.isEditHRAdminAndMDCEOApprovedIncrementPct = true;;
      }
    } else {
      if (this.selectedIncrementInputDept || this.selectedIncrementInputBand || this.selectedIncrementInputEmp || this.selectedIncrementInputManager) {
        const request = {
          "band": this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
          "employeeId": this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": false,
          "manager": this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputNonEligibleTableData = result.data;
          this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);
          this.totalNonEligibleCount = this.getIncrementInputNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": false,
          "manager": [],
          "search": this.searchIncrementInputTableData,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputNonEligibleTableData = result.data;
          this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);
          this.totalNonEligibleCount = this.getIncrementInputNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        });
      }
      this.isEditHODApprovedIncrementPct = true;
      this.isEditHRAdminAndMDCEOApprovedIncrementPct = false;
    }
  }
  calculateNonEligibleTotals(data: any[]): void {
    // Initialize total and count variables for all fields
    this.totalNonEligibleTotalFixedCtcPM = 0;
    this.totalNonEligibleTotalFixedCtcPA = 0;
    this.totalNonEligibleEligibleEmp = 0;
    this.totalNonEligibleFinalRating = 0;
    this.totalNonEligibleIncrementPct = 0;
    this.totalNonEligibleDaysServedinIncrementPeriod = 0;
    this.totalNonEligibleProratedIncrementPct = 0;
    this.totalNonEligibleHODIncrementPct = 0;
    this.totalNonEligibleHrAndMdIncrementPct = 0;
    this.totalNonEligibleIncrementAmount = 0;
    this.totalNonEligibleNoOfPromotionPct = 0;
    this.totalNonEligiblePromotionPct = 0;
    this.totalNonEligiblePromotionAmount = 0;
    this.totalNonEligibleupdatedCtcAfterIAndP = 0;
    this.totalNonEligibleMarketBenchMarkCtc = 0;
    this.totalNonEligiblemarketCorrectionPct = 0;
    this.totalNonEligibleMarketCorrectionAmount = 0;
    this.totalNonEligibleFinalIncrementPct = 0;
    this.totalNonEligibleFinalIncrementAmount = 0;
    this.totalNonEligibleFinalAnnualCtc = 0;
    this.totalNonEligibleFinalMonthlyCtc = 0;

    // Counters for calculating averages
    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          // Only process non-eligible employees
          if (!employee.isEligible) {
            this.totalNonEligibleTotalFixedCtcPM += parseFloat(employee.monthlyCtc || 0);
            this.totalNonEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
            this.totalNonEligibleEligibleEmp += 1;
            this.totalNonEligibleFinalRating += parseFloat(employee.finalRating || 0);

            // IncrementPct and count
            if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
              this.totalNonEligibleIncrementPct += parseFloat(employee.incrementPercentage);
              totalIncrementPctCount++;
            }

            // DaysServed and count
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.totalNonEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }

            // ProratedIncrementPct and count
            if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
              this.totalNonEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
              totalProratedIncrementPctCount++;
            }

            // HODIncrementPct and count
            if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
              this.totalNonEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
              totalHODIncrementPctCount++;
            }

            // HrAndMdIncrementPct and count
            if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
              this.totalNonEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
              totalHrAndMdIncrementPctCount++;
            }

            // PromotionPct and count
            if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
              this.totalNonEligiblePromotionPct += parseFloat(employee.promotionPercentage);
              totalPromotionPctCount++;
            }

            this.totalNonEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
            this.totalNonEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
            this.totalNonEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
            this.totalNonEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
            this.totalNonEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

            // FinalIncrementPct and count
            if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
              this.totalNonEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
              totalFinalIncrementPctCount++;
            }

            // MarketCorrectionPct and count
            if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
              this.totalNonEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
              totalMarketCorrectionPctCount++;
            }

            this.totalNonEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
            this.totalNonEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
            this.totalNonEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
            this.totalNonEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
          }
        });
      });
    });

    // Calculate averages for all percentage fields with valid counts
    if (totalFinalIncrementPctCount > 0) {
      this.totalNonEligibleFinalIncrementPct = parseFloat((this.totalNonEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.totalNonEligiblemarketCorrectionPct = parseFloat((this.totalNonEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.totalNonEligiblePromotionPct = parseFloat((this.totalNonEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.totalNonEligibleHODIncrementPct = parseFloat((this.totalNonEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.totalNonEligibleHrAndMdIncrementPct = parseFloat((this.totalNonEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.totalNonEligibleIncrementPct = parseFloat((this.totalNonEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.totalNonEligibleDaysServedinIncrementPeriod = parseFloat((this.totalNonEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }

    if (totalProratedIncrementPctCount > 0) {
      this.totalNonEligibleProratedIncrementPct = parseFloat((this.totalNonEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }


  getTotalRowSpan(bandGrades: any[]): number {
    let totalRows = 0;
    bandGrades.forEach(bandGrade => {
      totalRows += bandGrade.employeeData.length;
    });
    return totalRows;
  }

  onEditIncrementInputTableData(employee: any) {
    const request = {
      designation: employee.designation || null,
      hodIncrementPercentage: employee.hodIncrementPercentage || null,
      hrIncrementPercentage: employee.hrAndMdIncrementPercentage || null,
      inputId: employee.inputId,
      isEligible: employee.isEligible,
      isPromoted: employee.isPromoted,
      marketBenchmarkCtc: employee.marketBenchMarkCtc || null,
      marketCorrectionPercentage: employee.marketCorrectionPercentage || null,
      promotionPercentage: employee.promotionPercentage || null
    };
    this.httpService.callPostService(this.config.editIncrementInput, request).subscribe(result => {
      if (result) {
        this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);
        this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData)
        this.getIncrementInputisEligibleTableData();
        this.getIncrementInputisNonEligibleTableData();
        this.loader.simpleLoaderWithDuration();
      }

    });
  }

  onClickShowIncrementLetter(id: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      id: id,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getLetterOfUser, request).subscribe(
      (result: any) => {
        // this.http.get(result?.data, { responseType: 'blob' }).subscribe(
        //   (blob: any) => {
        //     const url = URL.createObjectURL(blob);
        //     window.open(url, '_blank');
        //     setTimeout(() => URL.revokeObjectURL(url), 100);
        //   },
        // );
        if (result?.data != null) {
          var fileName = result?.data?.split(environment.downloadURL)
          saveAs(result?.data, fileName[1]);
        }
      },
      (error) => {
        if (error.status === 500) {
          window.alert("Letter not found");
        }
      }
    );
  }

  // genreate increment letters btn
  onClickGenerateIncrementLetters() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Please fill the CTC breakup in employee master before proceeding or else you will see updated CTC with the old breakup',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/home/hrportal/increment/generateIncrementLetters']);
      }
    })
  }

  onCLickFreezforTheHOD() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to freeze the input file for all HODs?',
        btn1: 'Cancel',
        btn2: 'Freeze',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "fromYear": this.incrementFromYear,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.freezeForTheHod, request).subscribe((result: any) => { })
      }
    })

  }

  getFreezForTheHODStatus() {
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "fromYear": this.incrementFromYear,
    //   "toYear": this.incrementToYear
    // }
    // this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
    //   const status:any = result.data?.freezeForHod;
    //   if (status === true) {
    //     this.disableIncrementInputFormToHOD = true;
    //   } else {
    //     this.disableIncrementInputFormToHOD = false
    //   }
    // })
  }
  onCLickSendToMDForApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to send for approval',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "fromYear": this.incrementFromYear,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.sendToMdOrCeoForApproval, request).subscribe((result: any) => {
          if (result) {
            this.getMDApprovedData();
          }
        })
      }
    });
  }

  onCLickHODsendToHrAdminToApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to send for approval',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "department": "",
          "fromYear": this.incrementFromYear,
          "isApprovedByMd": true,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.approveByHod, request).subscribe((result: any) => {
          if (result.data === true) {
            this.getApproveByHodData();
          }
        })
      }
    })
  }

  getApproveByHodData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getApproveByHodData, request).subscribe((result: any) => {
      if (result.data?.approvalByHodDate) {
        this.approvalByHodDate = result.data.approvalByHodDate
        this.afterHODForApprovalDate = true;
      } else {
        this.afterHODForApprovalDate = false
      }
    })
  }

  // getDateAndTiemAfterMdOrCeoForApproval(){
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "toYear": this.toYear
  //   }
  //   this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result:any)=>{
  //     const status = result.data.freezeForHod;    
  //   })
  // }

  onClickMDRejectApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Reject the Increment?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.simpleLoaderWithDuration();
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "department": null,
          "fromYear": this.incrementFromYear,
          "isApprovedByMd": false,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.approveOrRejectByMD, request).subscribe((result: any) => {
          if (result) {
            this.getMDApprovedData();
          }
        })
      }
    });
  }

  onClickMDApproveAproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to approve the Increment?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.simpleLoaderWithDuration();
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "department": null,
          "fromYear": this.incrementFromYear,
          "isApprovedByMd": true,
          "toYear": this.incrementToYear
        }
        this.httpService.callPostService(this.config.approveOrRejectByMD, request).subscribe((result: any) => {
          if (result) {
            this.getMDApprovedData();
          }
        })
      }
    });
  }

  getMDApprovedData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      this.approvalStatus = result.data?.mdReviewStatus;
      this.approvalDateAndTime = result.data?.approvalByHrDate;
      const formattedDate = this.datePipe.transform(this.approvalDateAndTime, 'dd-MM-yyyy');
      this.isApprovedByHr = result.data?.isApprovedByHr
      if (result.data?.mdReviewStatus == "Approved") {
        this.afterMDAndCEOApproval = true;
        this.ShowIncrementInputStatus = `${this.approvalStatus} on ${formattedDate}`
        this.isHideFreezeForTheHodBtn = false;
        this.editedIndividualScoreId = null
        this.disableIncrementInputFormToHrAdmin = true;
        // this.isHideScoreToRatingConverterAddBtn = false;
      }
      else if (result.data?.mdReviewStatus == "Rejected") {
        this.ShowIncrementInputStatus = 'Rejected';
        this.disableIncrementInputFormToHrAdmin = false;
      }
      else {
        this.ShowIncrementInputStatus = 'Pending'
        this.afterMDAndCEOApproval = false
        this.disableIncrementInputFormToHrAdmin = false;
        this.isHideFreezeForTheHodBtn = true
      }

      // Approved or Reject Btn 
      if (result.data?.mdReviewStatus == "Approved" || result.data?.isApprovedByHr == false) {
        this.isDisableApproveBtnAfterMDApproved = true;
      } else {
        this.isDisableApproveBtnAfterMDApproved = false;
      }

      // Hod approved 
      const status: any = result.data?.freezeForHod;
      if (status === true && !this.isShowMD) {
        this.disableIncrementInputFormToHOD = true;
      } else {
        this.disableIncrementInputFormToHOD = false
      }

      // Send to MD/CEO for Approval 
      if (result.data?.isApprovedByHr == true) {
        this.disableBtnsOnsendApprovelForMD = true;
        if (this.isShowMD && result.data?.mdReviewStatus != "Approved") {
          this.disableIncrementInputFormToHrAdmin = false;
        } else {
          this.disableIncrementInputFormToHrAdmin = true;
        }
      } else {
        this.disableIncrementInputFormToHrAdmin = false;
        this.disableBtnsOnsendApprovelForMD = false;
      }

      if (result.data.isLetterSubmitted == true) {
        this.isDisabledFinalIncLettersBtn = true;
      } else {
        this.isDisabledFinalIncLettersBtn = false;
      }
    })
  }

  onClickSubmitIncrementLetters() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Letter Submited Successfully',
        btn1: 'Cancel',
        btn2: 'Ok',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "fromYear": this.fromYear,
          "incrementId": null,
          "toYear": this.toYear
        }
        this.httpService.callPostService(this.config.submitIncrementLetters, request).subscribe((result: any) => {
          if (result) {
            this.getMDApprovedData();
          }
        })
      }
    })
  }

  onClickDownloadIncrementInputExcelFile() {
    this.loader.simpleLoader()
    this.isShowExcelData = true;
    const tableName = this.activeIncrementInputTab ? 'incrementInputEligibleTable' : 'incrementInputNonEligibleTable';
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    if (tableName == 'incrementInputEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementInputEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                "Department": department.departmentName,
                "Band": band.band,
                "Employee": employee.employeeName,
                "Manager": employee.managerName,
                "HOD": employee.hodName,
                "Designation": employee.designation,
                "DOJ": formatDate(employee.dateOfJoining),
                "Total CTC p.m.": `${employee.monthlyCtc || 0}`,
                "Total CTC p.a.": `${employee.annualCtc || 0}`,
                "Eligible Emp.": employee.isEligible ? "Yes" : "No",
                "Individual KPI + Competency Score": `${employee.individualKpiCompetencyScore || 0}`,
                "Department Score (out of 100)": `${employee.deptScore || 0}`,
                "Company Score (out of 100)": `${employee.companyScore || 0}`,
                "Final Score": `${employee.finalScore || 0}`,
                "Final Rating": `${employee.finalRating || 0}`,
                "Increment %": `${employee.incrementPercentage || 0}`,
                "Days Served in the Increment Period": `${employee.daysServed || 0}`,
                "Prorated Increment %": `${employee.proratedIncrementPercentage || 0}`,
                "Increment Amount": `${employee.incrementAmount || 0}`,
                "No Promotion Last 3 Year": `${employee.noOfPromotions || 0}`,
                "Promotion": employee.isPromoted ? "Yes" : "No",
                "Promotion %": `${employee.promotionPercentage || 0}`,
                "Promotion Amount": `${employee.promotionAmount || 0}`,
                "Updated CTC after Increment & Promotion": `${employee.updatedCtcAfterIncrementAndPromotion || 0}`,
                "Market BenchMark CTC": `${employee.marketBenchMarkCtc || 0}`,
                "Market Correction %": `${employee.marketCorrectionPercentage || 0}`,
                "Market Correction Amount": `${employee.marketCorrectionAmount || 0}`,
                "Final Increment % p.a": `${employee.finalIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[0]}`]: `${employee.yearBeforeLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[1]}`]: `${employee.lastToLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[2]}`]: `${employee.lastYrIncrementPercentage || 0}`,
                "HOD Approved Increment %": `${employee.hodIncrementPercentage || 0}`,
                "HR Admin & MD/CEO Approved Increment %": `${employee.hrAndMdIncrementPercentage || 0}`,
                "Final Increment Amount": `${employee.finalIncrementAmount || 0}`,
                "Final Annual Revised CTC (post increment)": `${employee.finalAnnualCtc || 0}`,
                "Final Monthly Revised CTC (post increment)": `${employee.finalMonthlyCtc || 0}`,
                "Increment Letter Format": employee.incrementLetterFormat?.letterName || 'Letter not found',
              });
            });
          });
        });
        flattenedData.push({
          "Department": 'Total',
          "Band": '',
          "Employee": '',
          "Manager": '',
          "HOD": '',
          "Designation": '',
          "DOJ": '',
          "Total CTC p.m.": `${this.totalEligibleTotalFixedCtcPM}`,
          "Total CTC p.a.": `${this.totalEligibleTotalFixedCtcPA}`,
          "Eligible Emp.": `${this.totalEligibleEligibleEmp}`,
          "Individual KPI + Competency Score": '',
          "Department Score (out of 100)": '',
          "Company Score (out of 100)": '',
          "Final Score": '',
          "Final Rating": `${this.totalEligibleFinalRating}`,
          "Increment %": `${this.totalEligibleIncrementPct}`,
          "Days Served in the Increment Period": `${this.totalEligibleDaysServedinIncrementPeriod}`,
          "Prorated Increment %": `${this.totalEligibleProratedIncrementPct}`,
          "Increment Amount": `${this.totalEligibleIncrementAmount}`,
          "No Promotion Last 3 Year": `${this.totalEligibleNoOfPromotionPct}`,
          "Promotion": '',
          "Promotion %": `${this.totalEligiblePromotionPct}`,
          "Promotion Amount": `${this.totalEligiblePromotionAmount}`,
          "Updated CTC after Increment & Promotion": `${this.totalEligibleupdatedCtcAfterIAndP}`,
          "Market BenchMark CTC": `${this.totalEligibleMarketBenchMarkCtc}`,
          "Market Correction %": `${this.totalEligiblemarketCorrectionPct}`,
          "Market Correction Amount": `${this.totalEligibleMarketCorrectionAmount}`,
          "Final Increment % p.a": `${this.totalEligibleFinalIncrementPct}`,
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          "HOD Approved Increment %": `${this.totalEligibleHODIncrementPct}`,
          "HR Admin & MD/CEO Approved Increment %": `${this.totalEligibleHrAndMdIncrementPct}`,
          "Final Increment Amount": `${this.totalEligibleFinalIncrementAmount}`,
          "Final Annual Revised CTC (post increment)": `${this.totalEligibleFinalAnnualCtc}`,
          "Final Monthly Revised CTC (post increment)": `${this.totalEligibleFinalMonthlyCtc}`,
          "Increment Letter Format": '',
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: "left", vertical: "top" },
          font: { name: "Arial", sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
        const workbook: XLSX.WorkBook = {
          Sheets: { 'data': worksheet },
          SheetNames: ['data'],
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Input_Eligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    } else if (tableName == 'incrementInputNonEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementInputNonEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                "Department": department.departmentName,
                "Band": band.band,
                "Employee": employee.employeeName,
                "Manager": employee.managerName,
                "HOD": employee.hodName,
                "Designation": employee.designation,
                "DOJ": formatDate(employee.dateOfJoining),
                "Total CTC p.m.": `${employee.monthlyCtc || 0}`,
                "Total CTC p.a.": `${employee.annualCtc || 0}`,
                "Eligible Emp.": employee.isEligible ? "Yes" : "No",
                "Individual KPI + Competency Score": `${employee.individualKpiCompetencyScore || 0}`,
                "Department Score (out of 100)": `${employee.deptScore || 0}`,
                "Company Score (out of 100)": `${employee.companyScore || 0}`,
                "Final Score": `${employee.finalScore || 0}`,
                "Final Rating": `${employee.finalRating || 0}`,
                "Increment %": `${employee.incrementPercentage || 0}`,
                "Days Served in the Increment Period": `${employee.daysServed || 0}`,
                "Prorated Increment %": `${employee.proratedIncrementPercentage || 0}`,
                "Increment Amount": `${employee.incrementAmount || 0}`,
                "No Promotion Last 3 Year": `${employee.noOfPromotions || 0}`,
                "Promotion": employee.isPromoted ? "Yes" : "No",
                "Promotion %": `${employee.promotionPercentage || 0}`,
                "Promotion Amount": `${employee.promotionAmount || 0}`,
                "Updated CTC after Increment & Promotion": `${employee.updatedCtcAfterIncrementAndPromotion || 0}`,
                "Market BenchMark CTC": `${employee.marketBenchMarkCtc || 0}`,
                "Market Correction %": `${employee.marketCorrectionPercentage || 0}`,
                "Market Correction Amount": `${employee.marketCorrectionAmount || 0}`,
                "Final Increment % p.a": `${employee.finalIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[0]}`]: `${employee.yearBeforeLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[1]}`]: `${employee.lastToLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[2]}`]: `${employee.lastYrIncrementPercentage || 0}`,
                "HOD Approved Increment %": `${employee.hodIncrementPercentage || 0}`,
                "HR Admin & MD/CEO Approved Increment %": `${employee.hrAndMdIncrementPercentage || 0}`,
                "Final Increment Amount": `${employee.finalIncrementAmount || 0}`,
                "Final Annual Revised CTC (post increment)": `${employee.finalAnnualCtc || 0}`,
                "Final Monthly Revised CTC (post increment)": `${employee.finalMonthlyCtc || 0}`,
                "Increment Letter Format": employee.incrementLetterFormat?.letterName || 'Letter not found',
              });
            });
          });
        });
        flattenedData.push({
          "Department": 'Total',
          "Band": '',
          "Employee": '',
          "Manager": '',
          "HOD": '',
          "Designation": '',
          "DOJ": '',
          "Total CTC p.m.": `${this.totalNonEligibleTotalFixedCtcPM}`,
          "Total CTC p.a.": `${this.totalNonEligibleTotalFixedCtcPA}`,
          "Eligible Emp.": `${this.totalNonEligibleEligibleEmp}`,
          "Individual KPI + Competency Score": '',
          "Department Score (out of 100)": '',
          "Company Score (out of 100)": '',
          "Final Score": '',
          "Final Rating": `${this.totalNonEligibleFinalRating}`,
          "Increment %": `${this.totalNonEligibleIncrementPct}`,
          "Days Served in the Increment Period": `${this.totalNonEligibleDaysServedinIncrementPeriod}`,
          "Prorated Increment %": `${this.totalNonEligibleProratedIncrementPct}`,
          "Increment Amount": `${this.totalNonEligibleIncrementAmount}`,
          "No Promotion Last 3 Year": `${this.totalNonEligibleNoOfPromotionPct}`,
          "Promotion": '',
          "Promotion %": `${this.totalNonEligiblePromotionPct}`,
          "Promotion Amount": `${this.totalNonEligiblePromotionAmount}`,
          "Updated CTC after Increment & Promotion": `${this.totalNonEligibleupdatedCtcAfterIAndP}`,
          "Market BenchMark CTC": `${this.totalNonEligibleMarketBenchMarkCtc}`,
          "Market Correction %": `${this.totalNonEligiblemarketCorrectionPct}`,
          "Market Correction Amount": `${this.totalNonEligibleMarketCorrectionAmount}`,
          "Final Increment % p.a": `${this.totalNonEligibleFinalIncrementPct}`,
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          "HOD Approved Increment %": `${this.totalNonEligibleHODIncrementPct}`,
          "HR Admin & MD/CEO Approved Increment %": `${this.totalNonEligibleHrAndMdIncrementPct}`,
          "Final Increment Amount": `${this.totalNonEligibleFinalIncrementAmount}`,
          "Final Annual Revised CTC (post increment)": `${this.totalNonEligibleFinalAnnualCtc}`,
          "Final Monthly Revised CTC (post increment)": `${this.totalNonEligibleFinalMonthlyCtc}`,
          "Increment Letter Format": '',
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: "left", vertical: "top" },
          font: { name: "Arial", sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
        const workbook: XLSX.WorkBook = {
          Sheets: { 'data': worksheet },
          SheetNames: ['data'],
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Input_NonEligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    }
  }

  // Increment Summary
  getIncrementSummaryTableHideShowAllData() {
    if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
      this.incrementsummaryCtc = "Fixed CTC"

    } else {
      this.incrementsummaryCtc = "Total CTC"
    }
    this.IncrementSummaryTableHideShowAllData = [
      {
        "fieldId": 1,
        "isVisible": true,
        "fieldName": "Department",
        "position": 1,
        "isEditable": true
      },
      {
        "fieldId": 2,
        "isVisible": true,
        "fieldName": "Band",
        "position": 2,
        "isEditable": true
      },
      {
        "fieldId": 3,
        "isVisible": true,
        "fieldName": "Total Emp.",
        "position": 3,
        "isEditable": true
      },
      {
        "fieldId": 4,
        "isVisible": true,
        "fieldName": this.incrementsummaryCtc,
        "position": 4,
        "isEditable": true
      },
      {
        "fieldId": 5,
        "isVisible": true,
        "fieldName": "Eligible Emp.",
        "position": 5,
        "isEditable": true
      },
      {
        "fieldId": 6,
        "isVisible": true,
        "fieldName": "Eligible Emp. Fixed CTC",
        "position": 6,
        "isEditable": true
      },
      {
        "fieldId": 7,
        "isVisible": true,
        "fieldName": "Overall Increment Budget",
        "position": 7,
        "isEditable": true
      },
      {
        "fieldId": 8,
        "isVisible": true,
        "fieldName": "Increment Amount",
        "position": 8,
        "isEditable": true
      },
      {
        "fieldId": 9,
        "isVisible": true,
        "fieldName": "No of Promotions",
        "position": 9,
        "isEditable": true
      },
      {
        "fieldId": 10,
        "isVisible": true,
        "fieldName": "Promotion Amount",
        "position": 10,
        "isEditable": true
      },
      {
        "fieldId": 11,
        "isVisible": true,
        "fieldName": "No of Market Corrections",
        "position": 11,
        "isEditable": true
      },
      {
        "fieldId": 12,
        "isVisible": true,
        "fieldName": "Market Correction Amount",
        "position": 12,
        "isEditable": true
      },
      {
        "fieldId": 13,
        "isVisible": true,
        "fieldName": "Final Increment Amount",
        "position": 13,
        "isEditable": true
      },
      {
        "fieldId": 14,
        "isVisible": true,
        "fieldName": "Variance",
        "position": 14,
        "isEditable": true
      },
      {
        "fieldId": 15,
        "isVisible": true,
        "fieldName": "Variance %",
        "position": 15,
        "isEditable": true
      },
    ]
  }

  updateIncrementSummaryColumnVisibility(data: any, index: any) {
    this.IncrementSummaryTableHideShowAllData[index].isVisible = false;
  }

  onSelectIncrementSummaryHideShowCheckBox(event: any) {
    this.isAnyColumnInvisible = this.IncrementSummaryTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.IncrementSummaryTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  getIncrementSummaryColumnVisibility(fieldName: string): boolean {
    const column = this.IncrementSummaryTableHideShowAllData.find((item: any) => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  searchIncrementSummaryTableData: any = null;
  onIncrementSummarySearch(data: any) {
    var search = ''
    this.searchIncrementSummaryTableData = data;
    if (data == '') {
      this.searchIncrementSummaryTableData = null;
      this.getIncrementSummaryData();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getIncrementSummaryData();
          },
            500);
        }
      },
        1500);
    }
  }

  getIncrementSummaryData() {
    const request = {
      "band": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "employeeId": [],
      "fromYear": this.incrementFromYear,
      "isEligible": true,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "manager": [],
      "search": this.searchIncrementSummaryTableData,
      "toYear": this.incrementToYear
    };
    this.httpService.callPostService(this.config.getIncrementSummary, request).subscribe((result: any) => {
      this.getIncrementSummaryTableData = result.data;
    });
  }

  getDepartmentTotal(employeeSummaryData: { [key: string]: any }[], key: string): number {
    const total = employeeSummaryData.reduce((acc, employee) => {
      const value = parseFloat(employee[key]);
      return acc + (isNaN(value) ? 0 : value);
    }, 0);
    return total;
  }

  getOverallTotal(property: string): number {
    let total = 0;
    this.getIncrementSummaryTableData.forEach((department: any) => {
      department.employeeSummaryData.forEach((employee: any) => {
        total += employee[property];
      });
    });
    return total;
  }

  getGrandTotal(key: string): number {
    if (key === 'variancePercentage') {
      let variancePercentageSum = 0;
      let count = 0;

      this.getIncrementSummaryTableData.forEach((department: any) => {
        department.employeeSummaryData.forEach((employee: any) => {
          if (employee.variancePercentage != null) {
            variancePercentageSum += parseFloat(employee.variancePercentage);
            count++;
          }
        });
      });

      return count > 0 ? parseFloat((variancePercentageSum / count).toFixed(2)) : 0;
    } else {
      return this.getIncrementSummaryTableData.reduce((acc: any, department: any) => {
        return acc += this.getDepartmentTotal(department.employeeSummaryData, key);
      }, 0);
    }
  }


  getAggregatedBandTotals(): any[] {
    const bandTotals: any = {};
    this.getIncrementSummaryTableData.forEach((department: any) => {
      department.employeeSummaryData.forEach((employee: any) => {
        if (!bandTotals[employee.band]) {
          bandTotals[employee.band] = {
            totalEmp: 0,
            totalFixedCtc: 0,
            eligibleEmp: 0,
            eligibleEmpFixedCtc: 0,
            overallIncrementBudget: 0,
            incrementAmount: 0,
            noOfPromotions: 0,
            promotionAmount: 0,
            noOfMarketCorrections: 0,
            marketCorrectionAmount: 0,
            finalIncrementAmount: 0,
            variance: 0,
            variancePercentageSum: 0,
            variancePercentageCount: 0,
          };
        }

        // Summing numeric values
        bandTotals[employee.band].totalEmp += parseInt(employee.totalEmp || '0');
        bandTotals[employee.band].totalFixedCtc += parseFloat(employee.totalFixedCtc || '0');
        bandTotals[employee.band].eligibleEmp += parseFloat(employee.eligibleEmp || '0');
        bandTotals[employee.band].eligibleEmpFixedCtc += parseFloat(employee.eligibleEmpFixedCtc || '0');
        bandTotals[employee.band].overallIncrementBudget += parseFloat(employee.overallIncrementBudget || '0');
        bandTotals[employee.band].incrementAmount += parseFloat(employee.incrementAmount || '0');
        bandTotals[employee.band].noOfPromotions += parseFloat(employee.noOfPromotions || '0');
        bandTotals[employee.band].promotionAmount += parseFloat(employee.promotionAmount || '0');
        bandTotals[employee.band].noOfMarketCorrections += parseFloat(employee.noOfMarketCorrections || '0');
        bandTotals[employee.band].marketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || '0');
        bandTotals[employee.band].finalIncrementAmount += parseFloat(employee.finalIncrementAmount || '0');
        bandTotals[employee.band].variance += parseFloat(employee.variance || '0');
        if (employee.variancePercentage != null) {
          bandTotals[employee.band].variancePercentageSum += parseFloat(employee.variancePercentage);
          bandTotals[employee.band].variancePercentageCount++;
        }
      });
    });

    // Map to final result array
    return Object.keys(bandTotals).map(band => ({
      band: band,
      totalEmp: bandTotals[band].totalEmp,
      totalFixedCtc: bandTotals[band].totalFixedCtc,
      eligibleEmp: bandTotals[band].eligibleEmp,
      eligibleEmpFixedCtc: bandTotals[band].eligibleEmpFixedCtc,
      overallIncrementBudget: bandTotals[band].overallIncrementBudget,
      incrementAmount: bandTotals[band].incrementAmount,
      noOfPromotions: bandTotals[band].noOfPromotions,
      promotionAmount: bandTotals[band].promotionAmount,
      noOfMarketCorrections: bandTotals[band].noOfMarketCorrections,
      marketCorrectionAmount: bandTotals[band].marketCorrectionAmount,
      finalIncrementAmount: bandTotals[band].finalIncrementAmount,
      variance: bandTotals[band].variance,
      variancePercentage: bandTotals[band].variancePercentageCount > 0
        ? (bandTotals[band].variancePercentageSum / bandTotals[band].variancePercentageCount).toFixed(2) : '0.00'
    }));
  }


  onClickDownloadIncrementSummaryExcelFile(id: any) {
    this.loader.simpleLoader()
    this.isShowExcelData = true;
    setTimeout(() => {
      const tableId = id
      const table = document.getElementById(tableId) as HTMLTableElement;
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
      if (!table) {
        alert('Table not found!');
        return;
      }
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `Increment_Summary_${formattedDate}.xlsx`);
      this.isShowExcelData = false;
      this.loader.dismissLoader()
    }, 1000);
  }

  // Increment Reports

  IncrementReportsTableHideShowAllData: any[] = [];
  activeIncrementReportsTab: any = true
  getIncrementReportsEligibleTableData: any[] = []
  getIncrementReportsNonEligibleTableData: any[] = [];
  reportsTotalEligibleCount: any
  reportsTotalNonEligibleCount: any;

  selectedIncrementReportDep: any
  selectedIncrementReportBand: any;
  selectedIncrementReportDesignation: any
  selectedIncrementReportManager: any
  selectedIncrementReportEmployee: any
  selectedIncrementReportPromotion: any
  selectedIncrementReportMarketCorr: any
  selectedIncrementReportRating: any;

  getIncrementReportBandList: any[] = [];
  getIncrementReportDesignationList: any[] = [];
  getIncrementReportManagerList: any[] = [];
  getIncrementReportEmployeeList: any[] = [];
  getIncrementReportPromotionList: any[] = [];
  getIncrementReportMarketCorrList: any[] = [];
  getIncrementReportRatingList: any[] = [];

  onClickIncrementReportsActiveTab(data: any) {
    this.activeIncrementReportsTab = data
    console.warn(this.activeIncrementReportsTab);

    if (this.activeIncrementReportsTab == true) {
      this.checkIncrementDepartment = true;
      this.getDepartmentByYear();
      this.selectedIncrementReportDep = '';
      this.selectedIncrementReportBand = '';
      this.selectedIncrementReportDesignation = "";
      this.selectedIncrementReportManager = "";
      this.selectedIncrementReportEmployee = "";
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.selectedIncrementReportRating = "";
      this.getIncrementReportsEligibleData()
      this.getIncrementReportsNonEligibleData()
    } else if (this.activeIncrementReportsTab == false) {
      this.checkIncrementDepartment = false;
      this.getDepartmentByYear();
      this.selectedIncrementReportDep = '';
      this.selectedIncrementReportBand = '';
      this.selectedIncrementReportDesignation = "";
      this.selectedIncrementReportManager = "";
      this.selectedIncrementReportEmployee = "";
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.selectedIncrementReportRating = "";
      this.getIncrementReportsEligibleData()
      this.getIncrementReportsNonEligibleData()
    }
  }

  onSelectIncrementReportDep() {
    if (this.selectedIncrementReportDep.length > 0) {
      this.getIncrementReportBandList = [];
      this.selectedIncrementReportBand = "";
      this.getIncrementReportDesignationList = [];
      this.selectedIncrementReportDesignation = "";
      this.getIncrementReportManagerList = [];
      this.selectedIncrementReportManager = "";
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = "";
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = "";
      this.getIncrementReportBandByDep();
      this.getIncrementReportsEligibleData()
      this.getIncrementReportsNonEligibleData()
    }
  }

  onDeSelectIncrementReportDep() {
    this.getIncrementReportBandList = [];
    this.selectedIncrementReportBand = "";
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = "";
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportBandByDep();
    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  selectAllIncrementReportDep(items: any): void {
    this.selectedIncrementReportDep = items;
    this.getIncrementReportBandList = [];
    this.selectedIncrementReportBand = "";
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = "";
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.onSelectIncrementReportDep()
  }

  onDeSelectAllIncrementReportDep() {
    this.selectedIncrementReportDep = [];
    this.getIncrementReportBandList = [];
    this.selectedIncrementReportBand = "";
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = "";
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  // Select Band

  getIncrementReportBandByDep() {
    const request: any = {
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getBandListByDepartment, request)
      .subscribe((result: any) => {
        if (result.data) {
          this.getIncrementReportBandList = result.data.map((ele: any) => ({
            id: ele,
            name: ele
          })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
        }
      });
  }

  onSelectIncrementReportBand() {
    if (this.selectedIncrementReportBand.length > 0) {
      this.getIncrementReportDesignationList = [];
      this.selectedIncrementReportDesignation = "";
      this.getIncrementReportManagerList = [];
      this.selectedIncrementReportManager = "";
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = "";
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = "";

      this.getIncrementReportsDesignation();
      this.getIncrementReportsEligibleData()
      this.getIncrementReportsNonEligibleData()
    }
  }

  onDeSelectIncrementReportBand() {
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = "";
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsDesignation();
    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  selectAllIncrementReportBand(items: any): void {
    this.selectedIncrementReportBand = items
    this.onSelectIncrementReportBand();
  }

  onDeSelectAllIncrementReportBand() {
    this.selectedIncrementReportBand = [];
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = "";
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  // Designation

  getIncrementReportsDesignation() {
    const request = {
      "bands": this.selectedIncrementReportBand.map((band: any) => band.name),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedIncrementReportDep.map((dept: any) => dept.name),
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getDesignationsFromBands, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportDesignationList = result.data.map((ele: any) => ({
          id: ele,
          name: ele
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
      }
    })
  }

  onSelectIncrementReportDesignation() {
    if (this.selectedIncrementReportDesignation.length > 0) {
      this.getIncrementReportManagerList = [];
      this.selectedIncrementReportManager = "";
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = "";
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = "";

      this.getIncrementReportManagerByDesignation();
      this.getIncrementReportsEligibleData()
      this.getIncrementReportsNonEligibleData()
    }
  }

  onDeSelectIncrementReportDesignation() {
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  selectAllIncrementReportDesignation(item: any) {
    this.selectedIncrementReportDesignation = item;

    this.onSelectIncrementReportDesignation();
  }

  onDeSelectAllIncrementReportDesignation() {
    this.selectedIncrementReportDesignation = [];
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = "";
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }


  // Select Manager

  getIncrementReportManagerByDesignation() {
    const request: any = {
      bands: this.selectedIncrementReportBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getManagerListByBand, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportManagerList = result.data.map((ele: any) => ({
          name: ele.name,
          id: ele.id,
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
      }
    });
  }

  onSelectIncrementReportManager() {
    if (this.selectedIncrementReportManager.length > 0) {
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = "";
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = "";

      this.getIncrementReportsEmployeeByManager();
      this.getIncrementReportsEligibleData()
      this.getIncrementReportsNonEligibleData()
    }
  }

  onDeSelectIncrementReportManager() {
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  selectAllIncrementReportManager(item: any) {
    this.selectedIncrementReportManager = item;
    this.onSelectIncrementReportManager();
  }

  onDeSelectAllIncrementReportManager() {
    this.selectedIncrementReportManager = [];
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = "";
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData()
    this.getIncrementReportsNonEligibleData()
  }

  //  select Employee

  getIncrementReportsEmployeeByManager() {
    const request = {
      bands: this.selectedIncrementReportBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear,
      userId: this.selectedIncrementReportManager.map((ele: any) => ele.id),
      isEligible: this.checkIncrementDepartment
    }
    this.httpService.callPostService(this.config.getEmployeesListByManager, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportEmployeeList = result.data.map((ele: any) => ({
          name: ele.name,
          id: ele.id
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
      }
    });
  }

  onSelectIncrementReportEmployee() {
    if (this.selectedIncrementReportEmployee.length > 0) {
      this.getIncrementReportPromotionList = []
      this.getIncrementReportMarketCorrList = []
      this.getIncrementReportRatingList = []
      this.selectedIncrementReportRating = '';
      this.selectedIncrementReportPromotion = "";
      this.selectedIncrementReportMarketCorr = "";
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = "";

      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportEmployee() {
    this.getIncrementReportPromotionList = []
    this.getIncrementReportMarketCorrList = []
    this.getIncrementReportRatingList = []
    this.selectedIncrementReportRating = '';
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.onSelectIncrementReportEmployee();
    this.getIncrementReportsEligibleData();
  }

  selectAllIncrementReportEmployee(item: any) {
    this.selectedIncrementReportEmployee = item;
    this.getIncrementReportPromotionList = []
    this.getIncrementReportMarketCorrList = []
    this.getIncrementReportRatingList = []
    this.selectedIncrementReportRating = '';
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.onSelectIncrementReportEmployee();
  }

  onDeSelectAllIncrementReportEmployee() {
    this.selectedIncrementReportEmployee = [];
    this.getIncrementReportEmployeeList = [];
    this.getIncrementReportPromotionList = []
    this.getIncrementReportMarketCorrList = []
    this.getIncrementReportRatingList = []
    this.selectedIncrementReportRating = '';
    this.selectedIncrementReportPromotion = "";
    this.selectedIncrementReportMarketCorr = "";
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Promotion
  onSelectIncrementReportPromotion() {
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Market Correction
  onSelectIncrementReportMarketCorr() {
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = "";

    this.getIncrementReportRatings();
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Rating

  getIncrementReportRatings() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear,
      "userId": this.selectedIncrementReportEmployee.map((ele: any) => ele.id)
    }
    this.httpService.callPostService(this.config.getRatingsByUserId, request).subscribe((result: any) => {
      this.getIncrementReportRatingList = result.data.map((ele: any) => ({
        name: ele,
        id: ele,
      })).sort((a: any, b: any) => a.name.localeCompare(b.name));
    })
  }

  onSelectIncrementReportRating() {
    if (this.selectedIncrementReportRating.length > 0) {
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportRating() {
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  selectAllIncrementReportRating(item: any) {
    this.selectedIncrementReportRating = item;
    this.onSelectIncrementReportRating();
  }

  onDeSelectAllIncrementReportRating() {
    this.selectedIncrementReportRating = [];
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  getIncrementReportsTableHideShowAllData() {
    if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
      this.incrementCtcPerMonth = "Fixed CTC p.m."
      this.incrementCtcPerYear = "Fixed CTC p.a."

    } else {
      this.incrementCtcPerMonth = "Total CTC p.m."
      this.incrementCtcPerYear = "Total CTC p.a."
    }
    this.IncrementReportsTableHideShowAllData = [
      {
        "fieldId": 1,
        "isVisible": true,
        "fieldName": "Department",
        "position": 1,
        "isEditable": true
      },
      {
        "fieldId": 2,
        "isVisible": true,
        "fieldName": "Band",
        "position": 2,
        "isEditable": true
      },
      {
        "fieldId": 3,
        "isVisible": true,
        "fieldName": "Employee",
        "position": 3,
        "isEditable": true
      },
      {
        "fieldId": 4,
        "isVisible": true,
        "fieldName": "Manager",
        "position": 4,
        "isEditable": true
      },
      {
        "fieldId": 5,
        "isVisible": true,
        "fieldName": "HOD",
        "position": 5,
        "isEditable": true
      },
      {
        "fieldId": 6,
        "isVisible": true,
        "fieldName": "Designation",
        "position": 6,
        "isEditable": true
      },
      {
        "fieldId": 7,
        "isVisible": true,
        "fieldName": "DOJ",
        "position": 7,
        "isEditable": true
      },
      {
        "fieldId": 8,
        "isVisible": true,
        "fieldName": this.incrementCtcPerMonth,
        "position": 8,
        "isEditable": true
      },
      {
        "fieldId": 9,
        "isVisible": true,
        "fieldName": this.incrementCtcPerYear,
        "position": 9,
        "isEditable": true
      },
      {
        "fieldId": 10,
        "isVisible": true,
        "fieldName": "Eligible Emp.",
        "position": 10,
        "isEditable": true
      },
      {
        "fieldId": 11,
        "isVisible": true,
        "fieldName": "Individual KPI + Competency Score",
        "position": 11,
        "isEditable": true
      },
      {
        "fieldId": 12,
        "isVisible": true,
        "fieldName": "Department Score (out of 100)",
        "position": 12,
        "isEditable": true
      },
      {
        "fieldId": 13,
        "isVisible": true,
        "fieldName": "Company Score (out of 100)",
        "position": 13,
        "isEditable": true
      },
      {
        "fieldId": 14,
        "isVisible": true,
        "fieldName": "Final Score",
        "position": 14,
        "isEditable": true
      },
      {
        "fieldId": 15,
        "isVisible": true,
        "fieldName": "Final Rating",
        "position": 15,
        "isEditable": true
      },
      {
        "fieldId": 16,
        "isVisible": true,
        "fieldName": "Increment %",
        "position": 16,
        "isEditable": true
      },
      {
        "fieldId": 17,
        "isVisible": true,
        "fieldName": "Days Served in the Increment Period",
        "position": 17,
        "isEditable": true
      },
      {
        "fieldId": 18,
        "isVisible": true,
        "fieldName": "Prorated Increment %",
        "position": 18,
        "isEditable": true
      },
      {
        "fieldId": 19,
        "isVisible": true,
        "fieldName": "Increment Amount",
        "position": 19,
        "isEditable": true
      },
      {
        "fieldId": 20,
        "isVisible": true,
        "fieldName": "No Promotion Last 3 Year",
        "position": 20,
        "isEditable": true
      },
      {
        "fieldId": 21,
        "isVisible": true,
        "fieldName": "Promotion",
        "position": 21,
        "isEditable": true
      },
      {
        "fieldId": 22,
        "isVisible": true,
        "fieldName": "Promotion %",
        "position": 22,
        "isEditable": true
      },
      {
        "fieldId": 23,
        "isVisible": true,
        "fieldName": "Promotion Amount",
        "position": 23,
        "isEditable": true
      },
      {
        "fieldId": 24,
        "isVisible": true,
        "fieldName": "Updated CTC after Increment & Promotion",
        "position": 24,
        "isEditable": true
      },
      {
        "fieldId": 25,
        "isVisible": true,
        "fieldName": "Market BenchMark CTC",
        "position": 25,
        "isEditable": true
      },
      {
        "fieldId": 26,
        "isVisible": true,
        "fieldName": "Market Correction %",
        "position": 26,
        "isEditable": true
      },
      {
        "fieldId": 27,
        "isVisible": true,
        "fieldName": "Market Correction Amount",
        "position": 27,
        "isEditable": true
      },
      {
        "fieldId": 28,
        "isVisible": true,
        "fieldName": "Final Increment % p.a",
        "position": 28,
        "isEditable": true
      },
      {
        "fieldId": 29,
        "isVisible": true,
        "fieldName": `Increment % in ${(new Date()).getFullYear() - 3}`,
        "position": 29,
        "isEditable": true
      },
      {
        "fieldId": 30,
        "isVisible": true,
        "fieldName": `Increment % in ${(new Date()).getFullYear() - 2}`,
        "position": 30,
        "isEditable": true
      },
      {
        "fieldId": 31,
        "isVisible": true,
        "fieldName": `Increment % in ${(new Date()).getFullYear() - 1}`,
        "position": 31,
        "isEditable": true
      },
      {
        "fieldId": 32,
        "isVisible": true,
        "fieldName": "HOD Approved Increment %",
        "position": 32,
        "isEditable": true
      },
      {
        "fieldId": 33,
        "isVisible": true,
        "fieldName": "HR Admin & MD/CEO Approved Increment %",
        "position": 33,
        "isEditable": true
      },
      {
        "fieldId": 34,
        "isVisible": true,
        "fieldName": "Final Increment Amount",
        "position": 34,
        "isEditable": true
      },
      {
        "fieldId": 35,
        "isVisible": true,
        "fieldName": "Final Annual Revised CTC (post increment)",
        "position": 35,
        "isEditable": true
      },
      {
        "fieldId": 36,
        "isVisible": true,
        "fieldName": "Final Monthly Revised CTC (post increment)",
        "position": 36,
        "isEditable": true
      },
      {
        "fieldId": 37,
        "isVisible": true,
        "fieldName": "Increment Letter Format",
        "position": 37,
        "isEditable": true
      }
    ]
  }

  searchIncrementReportTableData: any = null;
  onIncrementReportSearch(data: any) {
    var search = ''
    this.searchIncrementReportTableData = data;
    if (data == '') {
      this.searchIncrementReportTableData = null;
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getIncrementReportsEligibleData();
            this.getIncrementReportsNonEligibleData();
          },
            500);
        }
      },
        1500);
    }
  }

  onClickIncrementReportsFileDownload(status: any) {
    let flattenedData: any = []
    if (status == true) {
      
      flattenedData = this.getIncrementReportsEligibleTableData.forEach((department: any) =>
        department.bandGrades.forEach((band: any) =>
          band.employeeData.forEach((employee: any) => {
          }
          ))
      );
    } else if (status == false) {

    }


    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Increment_Reports_data.xlsx';
    saveAs(data, fileName);
  }



  getIncrementReportsEligibleData() {
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          "band": this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand?.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep?.map((band: any) => band.name) : [],
          "designation": this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation?.map((band: any) => band.name) : [],
          "employeeId": this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee?.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": true,
          "manager": this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager?.map((ele: any) => ele.id) : [],
          "marketCorrection": this.selectedIncrementReportMarketCorr,
          "promotion": this.selectedIncrementReportPromotion,
          "ratings": this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating?.map((band: any) => band.name) : [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "designation": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": true,
          "manager": [],
          "marketCorrection": null,
          "promotion": null,
          "ratings": [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      }
    } else {
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          "band": this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand?.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep.map((dept: any) => dept.name) : [],
          "designation": this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation?.map((band: any) => band.name) : [],
          "employeeId": this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee?.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": false,
          "manager": this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager?.map((ele: any) => ele.id) : [],
          "marketCorrection": this.selectedIncrementReportMarketCorr,
          "promotion": this.selectedIncrementReportPromotion,
          "ratings": this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating?.map((band: any) => band.name) : [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "designation": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": true,
          "isHod": false,
          "manager": [],
          "marketCorrection": null,
          "promotion": null,
          "ratings": [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      }
    }
  }
  reportTotalEligibleTotalFixedCtcPM: any = 0;
  reportTotalEligibleTotalFixedCtcPA: any = 0;
  reportTotalEligibleEligibleEmp: any = 0;
  reportTotalEligibleIncrementPct: any = 0;
  reportTotalEligibleDaysServedinIncrementPeriod: any = 0;
  reportTotalEligibleProratedIncrementPct: any = 0;
  reportTotalEligibleHODIncrementPct: any = 0;
  reportTotalEligibleHrAndMdIncrementPct: any = 0;
  reportTotalEligibleIncrementAmount: any = 0;
  reportTotalEligibleNoOfPromotionPct: any = 0;
  reportTotalEligiblePromotionPct: any = 0;
  reportTotalEligiblePromotionAmount: any = 0;
  reportTotalEligibleupdatedCtcAfterIAndP: any = 0;
  reportTotalEligibleMarketBenchMarkCtc: any = 0;
  reportTotalEligiblemarketCorrectionPct: any = 0;
  reportTotalEligibleMarketCorrectionAmount: any = 0;
  reportTotalEligibleFinalIncrementPct: any = 0;
  reportTotalEligibleFinalIncrementAmount: any = 0;
  reportTotalEligibleFinalAnnualCtc: any = 0;
  reportTotalEligibleFinalMonthlyCtc: any = 0;

  calculateReportsEligibleTotals(data: any[]): void {
    // Initialize totals and counters for percentage fields
    this.reportTotalEligibleTotalFixedCtcPM = 0;
    this.reportTotalEligibleTotalFixedCtcPA = 0;
    this.reportTotalEligibleEligibleEmp = 0;
    this.reportTotalEligibleIncrementPct = 0;
    this.reportTotalEligibleDaysServedinIncrementPeriod = 0;
    this.reportTotalEligibleProratedIncrementPct = 0;
    this.reportTotalEligibleHODIncrementPct = 0;
    this.reportTotalEligibleHrAndMdIncrementPct = 0;
    this.reportTotalEligibleIncrementAmount = 0;
    this.reportTotalEligibleNoOfPromotionPct = 0;
    this.reportTotalEligiblePromotionPct = 0;
    this.reportTotalEligiblePromotionAmount = 0;
    this.reportTotalEligibleupdatedCtcAfterIAndP = 0;
    this.reportTotalEligibleMarketBenchMarkCtc = 0;
    this.reportTotalEligiblemarketCorrectionPct = 0;
    this.reportTotalEligibleMarketCorrectionAmount = 0;
    this.reportTotalEligibleFinalIncrementPct = 0;
    this.reportTotalEligibleFinalIncrementAmount = 0;
    this.reportTotalEligibleFinalAnnualCtc = 0;
    this.reportTotalEligibleFinalMonthlyCtc = 0;

    // Counters for averaging purposes
    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          if (employee.isEligible) {
            this.reportTotalEligibleTotalFixedCtcPM += parseFloat(employee.monthlyCtc || 0);
            this.reportTotalEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
            this.reportTotalEligibleEligibleEmp += 1;
            // IncrementPct and count
            if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
              this.reportTotalEligibleIncrementPct += parseFloat(employee.incrementPercentage);
              totalIncrementPctCount++;
            }

            // DaysServed and count
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.reportTotalEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }

            // ProratedIncrementPct and count
            if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
              this.reportTotalEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
              totalProratedIncrementPctCount++;
            }

            // HODIncrementPct and count
            if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
              this.reportTotalEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
              totalHODIncrementPctCount++;
            }

            // HrAndMdIncrementPct and count
            if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
              this.reportTotalEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
              totalHrAndMdIncrementPctCount++;
            }

            // PromotionPct and count
            if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
              this.reportTotalEligiblePromotionPct += parseFloat(employee.promotionPercentage);
              totalPromotionPctCount++;
            }

            this.reportTotalEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
            this.reportTotalEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
            this.reportTotalEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
            this.reportTotalEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
            this.reportTotalEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

            // FinalIncrementPct and count
            if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
              this.reportTotalEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
              totalFinalIncrementPctCount++;
            }

            // MarketCorrectionPct and count
            if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
              this.reportTotalEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
              totalMarketCorrectionPctCount++;
            }

            this.reportTotalEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
            this.reportTotalEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
            this.reportTotalEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
            this.reportTotalEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
          }
        });
      });
    });

    // Calculate averages for all percentage fields with valid counts
    if (totalFinalIncrementPctCount > 0) {
      this.reportTotalEligibleFinalIncrementPct = parseFloat((this.reportTotalEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.reportTotalEligiblemarketCorrectionPct = parseFloat((this.reportTotalEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.reportTotalEligiblePromotionPct = parseFloat((this.reportTotalEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.reportTotalEligibleHODIncrementPct = parseFloat((this.reportTotalEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.reportTotalEligibleHrAndMdIncrementPct = parseFloat((this.reportTotalEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.reportTotalEligibleIncrementPct = parseFloat((this.reportTotalEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.reportTotalEligibleDaysServedinIncrementPeriod = parseFloat((this.reportTotalEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }
    if (totalProratedIncrementPctCount > 0) {
      this.reportTotalEligibleProratedIncrementPct = parseFloat((this.reportTotalEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }

  getIncrementReportsNonEligibleData() {
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          "band": this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep.map((band: any) => band.name) : [],
          "designation": this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation.map((band: any) => band.name) : [],
          "employeeId": this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": true,
          "manager": this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager.map((ele: any) => ele.id) : [],
          "marketCorrection": this.selectedIncrementReportMarketCorr,
          "promotion": this.selectedIncrementReportPromotion,
          "ratings": this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating.map((band: any) => band.name) : [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsNonEligibleTableData = result.data;
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
          this.reportsTotalNonEligibleCount = this.getIncrementReportsNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "designation": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": true,
          "manager": [],
          "marketCorrection": null,
          "promotion": null,
          "ratings": [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsNonEligibleTableData = result.data;
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
          this.reportsTotalNonEligibleCount = this.getIncrementReportsNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      }
    } else {
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          "band": this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand.map((band: any) => band.name) : [],
          "companyId": this.loggedInUserCompanyID,
          "department": this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep.map((band: any) => band.name) : [],
          "designation": this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation.map((band: any) => band.name) : [],
          "employeeId": this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee.map((ele: any) => ele.id) : [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": false,
          "manager": this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager.map((ele: any) => ele.id) : [],
          "marketCorrection": this.selectedIncrementReportMarketCorr,
          "promotion": this.selectedIncrementReportPromotion,
          "ratings": this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating.map((band: any) => band.name) : [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsNonEligibleTableData = result.data;
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
          this.reportsTotalNonEligibleCount = this.getIncrementReportsNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      } else {
        const request = {
          "band": [],
          "companyId": this.loggedInUserCompanyID,
          "department": [],
          "designation": [],
          "employeeId": [],
          "fromYear": this.incrementFromYear,
          "isEligible": false,
          "isHod": false,
          "manager": [],
          "marketCorrection": null,
          "promotion": null,
          "ratings": [],
          "search": this.searchIncrementReportTableData,
          "toYear": this.incrementToYear,
        }
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsNonEligibleTableData = result.data;
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
          this.reportsTotalNonEligibleCount = this.getIncrementReportsNonEligibleTableData.reduce((total: number, department: any) => {
            return total + department.bandGrades.reduce((bandTotal: number, band: any) => {
              return bandTotal + band.employeeData.length;
            }, 0);
          }, 0);
        })
      }
    }
  }

  reportTotalNonEligibleTotalFixedCtcPM: any = 0;
  reportTotalNonEligibleTotalFixedCtcPA: any = 0;
  reportTotalNonEligibleEligibleEmp: any = 0;
  reportTotalNonEligibleIncrementPct: any = 0;
  reportTotalNonEligibleDaysServedinIncrementPeriod: any = 0;
  reportTotalNonEligibleProratedIncrementPct: any = 0;
  reportTotalNonEligibleHODIncrementPct: any = 0;
  reportTotalNonEligibleHrAndMdIncrementPct: any = 0;
  reportTotalNonEligibleIncrementAmount: any = 0;
  reportTotalNonEligibleNoOfPromotionPct: any = 0;
  reportTotalNonEligiblePromotionPct: any = 0;
  reportTotalNonEligiblePromotionAmount: any = 0;
  reportTotalNonEligibleupdatedCtcAfterIAndP: any = 0;
  reportTotalNonEligibleMarketBenchMarkCtc: any = 0;
  reportTotalNonEligiblemarketCorrectionPct: any = 0;
  reportTotalNonEligibleMarketCorrectionAmount: any = 0;
  reportTotalNonEligibleFinalIncrementPct: any = 0;
  reportTotalNonEligibleFinalIncrementAmount: any = 0;
  reportTotalNonEligibleFinalAnnualCtc: any = 0;
  reportTotalNonEligibleFinalMonthlyCtc: any = 0;

  calculateReportsNonEligibleTotals(data: any[]): void {
    // Initialize totals and counters for percentage fields
    this.reportTotalNonEligibleTotalFixedCtcPM = 0;
    this.reportTotalNonEligibleTotalFixedCtcPA = 0;
    this.reportTotalNonEligibleEligibleEmp = 0;
    this.reportTotalNonEligibleIncrementPct = 0;
    this.reportTotalNonEligibleDaysServedinIncrementPeriod = 0;
    this.reportTotalNonEligibleProratedIncrementPct = 0;
    this.reportTotalNonEligibleHODIncrementPct = 0;
    this.reportTotalNonEligibleHrAndMdIncrementPct = 0;
    this.reportTotalNonEligibleIncrementAmount = 0;
    this.reportTotalNonEligibleNoOfPromotionPct = 0;
    this.reportTotalNonEligiblePromotionPct = 0;
    this.reportTotalNonEligiblePromotionAmount = 0;
    this.reportTotalNonEligibleupdatedCtcAfterIAndP = 0;
    this.reportTotalNonEligibleMarketBenchMarkCtc = 0;
    this.reportTotalNonEligiblemarketCorrectionPct = 0;
    this.reportTotalNonEligibleMarketCorrectionAmount = 0;
    this.reportTotalNonEligibleFinalIncrementPct = 0;
    this.reportTotalNonEligibleFinalIncrementAmount = 0;
    this.reportTotalNonEligibleFinalAnnualCtc = 0;
    this.reportTotalNonEligibleFinalMonthlyCtc = 0;

    // Counters for averaging purposes
    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          if (!employee.isEligible) {
            this.reportTotalNonEligibleTotalFixedCtcPM += parseFloat(employee.annualCtc || 0);
            this.reportTotalNonEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
            this.reportTotalNonEligibleEligibleEmp += 1;

            // IncrementPct and count
            if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
              this.reportTotalNonEligibleIncrementPct += parseFloat(employee.incrementPercentage);
              totalIncrementPctCount++;
            }

            // DaysServed and count
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.reportTotalNonEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }

            // ProratedIncrementPct and count
            if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
              totalProratedIncrementPctCount++;
            }

            // HODIncrementPct and count
            if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
              totalHODIncrementPctCount++;
            }

            // HrAndMdIncrementPct and count
            if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
              totalHrAndMdIncrementPctCount++;
            }

            // PromotionPct and count
            if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
              this.reportTotalNonEligiblePromotionPct += parseFloat(employee.promotionPercentage);
              totalPromotionPctCount++;
            }

            this.reportTotalNonEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
            this.reportTotalNonEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
            this.reportTotalNonEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
            this.reportTotalNonEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
            this.reportTotalNonEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

            // FinalIncrementPct and count
            if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
              totalFinalIncrementPctCount++;
            }

            // MarketCorrectionPct and count
            if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
              this.reportTotalNonEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
              totalMarketCorrectionPctCount++;
            }

            this.reportTotalNonEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
            this.reportTotalNonEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
            this.reportTotalNonEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
            this.reportTotalNonEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
          }
        });
      });
    });

    // Calculate averages for all percentage fields with valid counts
    if (totalFinalIncrementPctCount > 0) {
      this.reportTotalNonEligibleFinalIncrementPct = parseFloat((this.reportTotalNonEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.reportTotalNonEligiblemarketCorrectionPct = parseFloat((this.reportTotalNonEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.reportTotalNonEligiblePromotionPct = parseFloat((this.reportTotalNonEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.reportTotalNonEligibleHODIncrementPct = parseFloat((this.reportTotalNonEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.reportTotalNonEligibleHrAndMdIncrementPct = parseFloat((this.reportTotalNonEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.reportTotalNonEligibleIncrementPct = parseFloat((this.reportTotalNonEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.reportTotalNonEligibleDaysServedinIncrementPeriod = parseFloat((this.reportTotalNonEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }
    if (totalProratedIncrementPctCount > 0) {
      this.reportTotalNonEligibleProratedIncrementPct = parseFloat((this.reportTotalNonEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }

  onClickDownloadIncrementReportstExcelFile() {
    this.loader.simpleLoader()
    this.isShowExcelData = true;
    const tableName = this.activeIncrementReportsTab ? 'incrementReportsEligibleTable' : 'incrementReportsNonEligibleTable';
    if (tableName == 'incrementReportsEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementReportsEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                "Department": department.departmentName,
                "Band": band.band,
                "Employee": employee.employeeName,
                "Manager": employee.managerName,
                "HOD": employee.hodName,
                "Designation": employee.designation,
                "DOJ": formatDate(employee.dateOfJoining),
                "Total CTC p.m.": `${employee.monthlyCtc || 0}`,
                "Total CTC p.a.": `${employee.annualCtc || 0}`,
                "Eligible Emp.": employee.isEligible ? "Yes" : "No",
                "Individual KPI + Competency Score": `${employee.individualKpiCompetencyScore || 0}`,
                "Department Score (out of 100)": `${employee.deptScore || 0}`,
                "Company Score (out of 100)": `${employee.companyScore || 0}`,
                "Final Score": `${employee.finalScore || 0}`,
                "Final Rating": `${employee.finalRating || 0}`,
                "Increment %": `${employee.incrementPercentage || 0}`,
                "Days Served in the Increment Period": `${employee.daysServed || 0}`,
                "Prorated Increment %": `${employee.proratedIncrementPercentage || 0}`,
                "Increment Amount": `${employee.incrementAmount || 0}`,
                "No Promotion Last 3 Year": `${employee.noOfPromotions || 0}`,
                "Promotion": employee.isPromoted ? "Yes" : "No",
                "Promotion %": `${employee.promotionPercentage || 0}`,
                "Promotion Amount": `${employee.promotionAmount || 0}`,
                "Updated CTC after Increment & Promotion": `${employee.updatedCtcAfterIncrementAndPromotion || 0}`,
                "Market BenchMark CTC": `${employee.marketBenchMarkCtc || 0}`,
                "Market Correction %": `${employee.marketCorrectionPercentage || 0}`,
                "Market Correction Amount": `${employee.marketCorrectionAmount || 0}`,
                "Final Increment % p.a": `${employee.finalIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[0]}`]: `${employee.yearBeforeLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[1]}`]: `${employee.lastToLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[2]}`]: `${employee.lastYrIncrementPercentage || 0}`,
                "HOD Approved Increment %": `${employee.hodIncrementPercentage || 0}`,
                "HR Admin & MD/CEO Approved Increment %": `${employee.hrAndMdIncrementPercentage || 0}`,
                "Final Increment Amount": `${employee.finalIncrementAmount || 0}`,
                "Final Annual Revised CTC (post increment)": `${employee.finalAnnualCtc || 0}`,
                "Final Monthly Revised CTC (post increment)": `${employee.finalMonthlyCtc || 0}`,
                "Increment Letter Format": employee.incrementLetterFormat?.letterName || 'Letter not found',
              });
            });
          });
        });
        flattenedData.push({
          "Department": 'Total',
          "Band": '',
          "Employee": '',
          "Manager": '',
          "HOD": '',
          "Designation": '',
          "DOJ": '',
          "Total CTC p.m.": `${this.reportTotalEligibleTotalFixedCtcPM}`,
          "Total CTC p.a.": `${this.reportTotalEligibleTotalFixedCtcPA}`,
          "Eligible Emp.": `${this.reportTotalEligibleEligibleEmp}`,
          "Individual KPI + Competency Score": '',
          "Department Score (out of 100)": '',
          "Company Score (out of 100)": '',
          "Final Score": '',
          "Final Rating": '',
          "Increment %": `${this.reportTotalEligibleIncrementPct}`,
          "Days Served in the Increment Period": `${this.reportTotalEligibleDaysServedinIncrementPeriod}`,
          "Prorated Increment %": `${this.reportTotalEligibleProratedIncrementPct}`,
          "Increment Amount": `${this.reportTotalEligibleIncrementAmount}`,
          "No Promotion Last 3 Year": `${this.reportTotalEligibleNoOfPromotionPct}`,
          "Promotion": '',
          "Promotion %": `${this.reportTotalEligiblePromotionPct}`,
          "Promotion Amount": `${this.reportTotalEligiblePromotionAmount}`,
          "Updated CTC after Increment & Promotion": `${this.reportTotalEligibleupdatedCtcAfterIAndP}`,
          "Market BenchMark CTC": `${this.reportTotalEligibleMarketBenchMarkCtc}`,
          "Market Correction %": `${this.reportTotalEligiblemarketCorrectionPct}`,
          "Market Correction Amount": `${this.reportTotalEligibleMarketCorrectionAmount}`,
          "Final Increment % p.a": `${this.reportTotalEligibleFinalIncrementPct}`,
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          "HOD Approved Increment %": `${this.reportTotalEligibleHODIncrementPct}`,
          "HR Admin & MD/CEO Approved Increment %": `${this.reportTotalEligibleHrAndMdIncrementPct}`,
          "Final Increment Amount": `${this.reportTotalEligibleFinalIncrementAmount}`,
          "Final Annual Revised CTC (post increment)": `${this.reportTotalEligibleFinalAnnualCtc}`,
          "Final Monthly Revised CTC (post increment)": `${this.reportTotalEligibleFinalMonthlyCtc}`,
          "Increment Letter Format": '',
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: "left", vertical: "top" },
          font: { name: "Arial", sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
        const workbook: XLSX.WorkBook = {
          Sheets: { 'data': worksheet },
          SheetNames: ['data'],
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Report_Eligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    } else if (tableName == 'incrementReportsNonEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementReportsNonEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                "Department": department.departmentName,
                "Band": band.band,
                "Employee": employee.employeeName,
                "Manager": employee.managerName,
                "HOD": employee.hodName,
                "Designation": employee.designation,
                "DOJ": formatDate(employee.dateOfJoining),
                "Total CTC p.m.": `${employee.monthlyCtc || 0}`,
                "Total CTC p.a.": `${employee.annualCtc || 0}`,
                "Eligible Emp.": employee.isEligible ? "Yes" : "No",
                "Individual KPI + Competency Score": `${employee.individualKpiCompetencyScore || 0}`,
                "Department Score (out of 100)": `${employee.deptScore || 0}`,
                "Company Score (out of 100)": `${employee.companyScore || 0}`,
                "Final Score": `${employee.finalScore || 0}`,
                "Final Rating": `${employee.finalRating || 0}`,
                "Increment %": `${employee.incrementPercentage || 0}`,
                "Days Served in the Increment Period": `${employee.daysServed || 0}`,
                "Prorated Increment %": `${employee.proratedIncrementPercentage || 0}`,
                "Increment Amount": `${employee.incrementAmount || 0}`,
                "No Promotion Last 3 Year": `${employee.noOfPromotions || 0}`,
                "Promotion": employee.isPromoted ? "Yes" : "No",
                "Promotion %": `${employee.promotionPercentage || 0}`,
                "Promotion Amount": `${employee.promotionAmount || 0}`,
                "Updated CTC after Increment & Promotion": `${employee.updatedCtcAfterIncrementAndPromotion || 0}`,
                "Market BenchMark CTC": `${employee.marketBenchMarkCtc || 0}`,
                "Market Correction %": `${employee.marketCorrectionPercentage || 0}`,
                "Market Correction Amount": `${employee.marketCorrectionAmount || 0}`,
                "Final Increment % p.a": `${employee.finalIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[0]}`]: `${employee.yearBeforeLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[1]}`]: `${employee.lastToLastYrIncrementPercentage || 0}`,
                [`Increment % in ${lastThreeYears[2]}`]: `${employee.lastYrIncrementPercentage || 0}`,
                "HOD Approved Increment %": `${employee.hodIncrementPercentage || 0}`,
                "HR Admin & MD/CEO Approved Increment %": `${employee.hrAndMdIncrementPercentage || 0}`,
                "Final Increment Amount": `${employee.finalIncrementAmount || 0}`,
                "Final Annual Revised CTC (post increment)": `${employee.finalAnnualCtc || 0}`,
                "Final Monthly Revised CTC (post increment)": `${employee.finalMonthlyCtc || 0}`,
                "Increment Letter Format": employee.incrementLetterFormat?.letterName || 'Letter not found',
              });
            });
          });
        });
        flattenedData.push({
          "Department": 'Total',
          "Band": '',
          "Employee": '',
          "Manager": '',
          "HOD": '',
          "Designation": '',
          "DOJ": '',
          "Total CTC p.m.": `${this.reportTotalNonEligibleTotalFixedCtcPM}`,
          "Total CTC p.a.": `${this.reportTotalNonEligibleTotalFixedCtcPA}`,
          "Eligible Emp.": `${this.reportTotalNonEligibleEligibleEmp}`,
          "Individual KPI + Competency Score": '',
          "Department Score (out of 100)": '',
          "Company Score (out of 100)": '',
          "Final Score": '',
          "Final Rating": ``,
          "Increment %": `${this.reportTotalNonEligibleIncrementPct}`,
          "Days Served in the Increment Period": `${this.reportTotalNonEligibleDaysServedinIncrementPeriod}`,
          "Prorated Increment %": `${this.reportTotalNonEligibleProratedIncrementPct}`,
          "Increment Amount": `${this.reportTotalNonEligibleIncrementAmount}`,
          "No Promotion Last 3 Year": `${this.reportTotalNonEligibleNoOfPromotionPct}`,
          "Promotion": '',
          "Promotion %": `${this.reportTotalNonEligiblePromotionPct}`,
          "Promotion Amount": `${this.reportTotalNonEligiblePromotionAmount}`,
          "Updated CTC after Increment & Promotion": `${this.reportTotalNonEligibleupdatedCtcAfterIAndP}`,
          "Market BenchMark CTC": `${this.reportTotalNonEligibleMarketBenchMarkCtc}`,
          "Market Correction %": `${this.reportTotalNonEligiblemarketCorrectionPct}`,
          "Market Correction Amount": `${this.reportTotalNonEligibleMarketCorrectionAmount}`,
          "Final Increment % p.a": `${this.reportTotalNonEligibleFinalIncrementPct}`,
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          "HOD Approved Increment %": `${this.reportTotalNonEligibleHODIncrementPct}`,
          "HR Admin & MD/CEO Approved Increment %": `${this.reportTotalNonEligibleHrAndMdIncrementPct}`,
          "Final Increment Amount": `${this.reportTotalNonEligibleFinalIncrementAmount}`,
          "Final Annual Revised CTC (post increment)": `${this.reportTotalNonEligibleFinalAnnualCtc}`,
          "Final Monthly Revised CTC (post increment)": `${this.reportTotalNonEligibleFinalMonthlyCtc}`,
          "Increment Letter Format": '',
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: "left", vertical: "top" },
          font: { name: "Arial", sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({ wpx: 200 }));
        const workbook: XLSX.WorkBook = {
          Sheets: { 'data': worksheet },
          SheetNames: ['data'],
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Report_NonEligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    }
  }

  // Download Increment Policy

  donwloadIncrementPolicy() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      const downloadFile: any = result.data;
      if (downloadFile.incrementPolicyUrl) {
        var fileName: any = downloadFile.incrementPolicyUrl.split(environment.downloadURL)
        saveAs(downloadFile.incrementPolicyUrl, fileName[1]);
        //  saveAs(environment.downloadURL+downloadFile.incrementPolicyUrl,downloadFile.incrementPolicyUrl);
      }
    })
  }

  // Manager View and employee view
  sendApproveForIsPromoted() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "isHod": null,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.isEmployeePromoted, request).subscribe((result: any) => {
      if (result.data === true) {
        this.ShowApproveForIsPromotedContent = true;
      } else {
        this.ShowApproveForIsPromotedContent = false;
      }
    })
  }


  getFormatedDate(dateOfJoining: any) {
    return this.datePipe.transform(dateOfJoining, "dd-MM-YYYY");
  }

  getLetterAfterApprovel() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      if (result.data?.mdReviewStatus == "Approved") {
        this.showIncrementLetterForEmp = true;
      } else {
        this.showIncrementLetterForEmp = false
      }
    })
  }

  onClickDownloadIncrementLetterForEmp() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.incrementFromYear,
      "id": this.loggedInUserId,
      "toYear": this.incrementToYear
    }
    this.httpService.callPostService(this.config.getLetterOfUser, request).subscribe((result: any) => {
      if (result?.data != null) {
        if (this.showIncrementLetterForEmp == true) {
          var fileName = result?.data?.split(environment.downloadURL)
          saveAs(result?.data, fileName[1]);
        } else {
          window.alert("Increment Letter is not assign");
        }
      }
    },
      (error) => {
        if (error.status === 500) {
          window.alert("Increment Letter is not assign");
        }
      });
  }

}



